// before 20-5-2026

// last code with 5 quastions and redirect link

// import React, { useEffect, useState } from 'react';
// import Container from 'react-bootstrap/esm/Container';
// import Row from 'react-bootstrap/Row';
// import { useDispatch, useSelector } from 'react-redux';
// import { Getalldatasearch, Getalldatasearch2, InsertuserData } from '../Redux/Actions/UsersAction';
// import { Notify } from '../Utility/Notify';
// import AddIcon from '@mui/icons-material/Add';
// import RemoveIcon from '@mui/icons-material/Remove'; // ✅ أيقونة المسح
// import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer'; // ✅ أيقونة الأسئلة
// import InputLabel from '@mui/material/InputLabel';
// import FormControl from '@mui/material/FormControl';
// import { GetallProjectsdata } from '../Redux/Actions/Projects_Action';
// import {
//   Autocomplete,
//   Box,
//   MenuItem,
//   Select,
//   TextField,
//   Typography,
//   IconButton,
//   Paper,
// } from '@mui/material'; // ✅ أضفنا IconButton و Paper
// import { Get_All_Sales_Action } from '../Redux/Actions/SalesAction';
// import { GetAll_stage_Data } from '../Redux/Actions/Stage_Action';
// import { GetAllchannalData } from '../Redux/Actions/ChannalActions';
// import { GetCommunicationwayData } from '../Redux/Actions/CommunicationWay_Action';
// import Switch from '@mui/material/Switch';
// import { Col } from 'react-bootstrap';
// import PhoneInput from 'react-phone-input-2';
// import 'react-phone-input-2/lib/style.css';
// import { parsePhoneNumberFromString } from 'libphonenumber-js';
// import { GetAllCampainData } from '../Redux/Actions/Campaign_Actions';
// import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
// import { useTheme } from '@mui/material/styles';
// import { Link } from 'react-router-dom';
// import emailjs from 'emailjs-com';
// import CircularProgress from '@mui/material/CircularProgress';
// import axios from 'axios';

// export const AddClients = () => {
//   const theme = useTheme();
//   const mode = theme.palette.mode;
//   const dispatch = useDispatch();

//   // ========== ⭐⭐ NEW: Questions State ==========
//   const [questions, setQuestions] = useState([{ id: 1, question: '', answer: '' }]);
//   const [nextQuestionId, setNextQuestionId] = useState(2);

//   // دالة لإضافة سؤال جديد
//   const addQuestion = () => {
//     setQuestions([...questions, { id: nextQuestionId, question: '', answer: '' }]);
//     setNextQuestionId(nextQuestionId + 1);
//   };

//   // دالة لحذف سؤال
//   const removeQuestion = (id) => {
//     if (questions.length > 1) {
//       setQuestions(questions.filter((q) => q.id !== id));
//     } else {
//       Notify('info', 'You need at least one question', 'Info');
//     }
//   };

//   // دالة لتحديث نص السؤال
//   const updateQuestionText = (id, value) => {
//     setQuestions(questions.map((q) => (q.id === id ? { ...q, question: value } : q)));
//   };

//   // دالة لتحديث الإجابة
//   const updateQuestionAnswer = (id, value) => {
//     setQuestions(questions.map((q) => (q.id === id ? { ...q, answer: value } : q)));
//   };

//   const [userlogin, setuserlogin] = useState(null);
//   useEffect(() => {
//     try {
//       const userData = localStorage.getItem('user');
//       if (userData) {
//         const parsedUser = JSON.parse(userData);
//         setuserlogin(parsedUser);
//       }
//     } catch (error) {
//       console.error('Error parsing user data:', error);
//       setuserlogin(null);
//     }
//   }, []);

//   const [submitLoading, setSubmitLoading] = useState(false);

//   //phone - غيرت القيم الابتدائية ل strings فاضية
//   const [value, setValue] = useState('');
//   const [phonenumber2, setphonenumber2] = useState('');
//   const [whatsappnumber, setwhatsappnumber] = useState('');

//   // ⭐⭐ الحقل المخفي للبحث بدون علامة +
//   const [cleanPhoneForSearch, setCleanPhoneForSearch] = useState('');

//   const [error, setError] = useState('');
//   const [Errorphonenumber2, setErrorphonenumber2] = useState('');
//   const [whatsappnumbererror, setwhatsappnumbererror] = useState('');

//   // أضف هذه الـ states
//   const [isPhoneDuplicate, setIsPhoneDuplicate] = useState(false);
//   const [duplicateLeadInfo, setDuplicateLeadInfo] = useState(null);

//   const [countryName, setCountryName] = useState('');
//   const [selectedcountry, setselectedcountry] = useState('');
// const [campaignRedirectLink, setCampaignRedirectLink] = useState('');
// const onCampaignRedirectLinkChange = (e) => {
//   setCampaignRedirectLink(e.target.value);
// };
//   // استخدم useSelector للحصول على جميع المستخدمين مباشرة
//   const allUsers = useSelector((state) => state.Allusers?.Get_users?.data || []);

//   // دالة لتنظيف الرقم من الرموز والمسافات وعلامة +
//   const cleanPhoneNumber = (phone) => {
//     if (!phone) return '';
//     // ⭐⭐ إزالة كل ما عدا الأرقام فقط (بدون علامة +)
//     return phone.replace(/[^\d]/g, '');
//   };

//   // إعادة تعيين حقول التليفون إلى رمز دولة الإمارات فقط
//   const resetPhoneFields = () => {
//     setValue(''); // سيتم إعادة تعيينها لرمز دولة الإمارات فقط
//     setphonenumber2(''); // رمز دولة الإمارات فقط
//     setwhatsappnumber(''); // رمز دولة الإمارات فقط
//   };

//   const handlePhoneChange = async (newValue, countryData) => {
//     // تأكد من أن القيمة بتكون كاملة مع رمز الدولة
//     setValue(newValue);
//     setIsPhoneDuplicate(false);
//     setDuplicateLeadInfo(null);
//     setError('');

//     if (countryData) {
//       setCountryName(countryData.name);
//     }

//     // ⭐⭐ تنظيف الرقم بدون علامة + وحفظه في الحقل المخفي
//     const cleanPhoneWithoutPlus = cleanPhoneNumber(newValue);
//     setCleanPhoneForSearch(cleanPhoneWithoutPlus);
//   };

//   // دالة للبحث عن الرقم المكرر
//   const checkPhoneDuplicate = async (cleanPhoneWithoutPlus) => {
//     if (!cleanPhoneWithoutPlus || cleanPhoneWithoutPlus.length < 5) {
//       setIsPhoneDuplicate(false);
//       setDuplicateLeadInfo(null);
//       return;
//     }

//     try {
//       // البحث في البيانات المحلية أولاً
//       const duplicateInLocal = allUsers.find((user) => {
//         if (!user.phone) return false;
//         const userPhoneClean = cleanPhoneNumber(user.phone);
//         return userPhoneClean === cleanPhoneWithoutPlus;
//       });

//       if (duplicateInLocal) {
//         setIsPhoneDuplicate(true);
//         setDuplicateLeadInfo({
//           leadName: duplicateInLocal.name,
//           salesName: duplicateInLocal.sales?.name || 'No Sales',
//           salesEmail: duplicateInLocal.sales?.userlog?.email || 'No Email',
//           leadId: duplicateInLocal._id,
//           dateAdded: duplicateInLocal.date
//             ? new Date(duplicateInLocal.date).toLocaleDateString()
//             : 'Unknown',
//         });
//         return;
//       }

//       // إذا لم يوجد في البيانات المحلية، البحث في السيرفر
//       const result = await dispatch(Getalldatasearch2(`phone=${cleanPhoneWithoutPlus}`));

//       if (result?.payload?.data && result.payload.data.length > 0) {
//         const duplicateLead = result.payload.data[0];
//         setIsPhoneDuplicate(true);
//         setDuplicateLeadInfo({
//           leadName: duplicateLead.name || duplicateLead.leadname,
//           salesName:
//             duplicateLead.sales?.name ||
//             duplicateLead.salesname?.name ||
//             duplicateLead.salesname ||
//             'No Sales Assigned',
//           salesEmail:
//             duplicateLead.sales?.userlog?.email ||
//             duplicateLead.salesname?.userlog?.email ||
//             'No Email',
//           leadId: duplicateLead._id,
//           dateAdded: duplicateLead.date
//             ? new Date(duplicateLead.date).toLocaleDateString()
//             : 'Unknown',
//         });
//       } else {
//         setIsPhoneDuplicate(false);
//         setDuplicateLeadInfo(null);
//       }
//     } catch (error) {
//       console.error('Error in phone search:', error);
//       setIsPhoneDuplicate(false);
//       setDuplicateLeadInfo(null);
//     }
//   };

//   // دالة للتحقق من الدوبليكات قبل الـ submit
//   const validatePhoneBeforeSubmit = async () => {
//     if (!value) return false;

//     const cleanPhoneWithoutPlus = cleanPhoneNumber(value);

//     try {
//       // البحث في البيانات المحلية أولاً
//       const duplicateInLocal = allUsers.find((user) => {
//         if (!user.phone) return false;
//         const userPhoneClean = cleanPhoneNumber(user.phone);
//         return userPhoneClean === cleanPhoneWithoutPlus;
//       });

//       if (duplicateInLocal) {
//         setDuplicateLeadInfo({
//           leadName: duplicateInLocal.name,
//           salesName: duplicateInLocal.sales?.name || 'No Sales',
//           salesEmail: duplicateInLocal.sales?.userlog?.email || 'No Email',
//           leadId: duplicateInLocal._id,
//           dateAdded: duplicateInLocal.date
//             ? new Date(duplicateInLocal.date).toLocaleDateString()
//             : 'Unknown',
//         });
//         return true;
//       }

//       // إذا لم يوجد في البيانات المحلية، البحث في السيرفر
//       const result = await dispatch(Getalldatasearch2(`phone=${cleanPhoneWithoutPlus}`));

//       if (result?.payload?.data && result.payload.data.length > 0) {
//         const duplicateLead = result.payload.data[0];
//         setDuplicateLeadInfo({
//           leadName: duplicateLead.name || duplicateLead.leadname,
//           salesName:
//             duplicateLead.sales?.name ||
//             duplicateLead.salesname?.name ||
//             duplicateLead.salesname ||
//             'No Sales Assigned',
//           salesEmail:
//             duplicateLead.sales?.userlog?.email ||
//             duplicateLead.salesname?.userlog?.email ||
//             'No Email',
//           leadId: duplicateLead._id,
//           dateAdded: duplicateLead.date
//             ? new Date(duplicateLead.date).toLocaleDateString()
//             : 'Unknown',
//         });
//         return true;
//       }

//       return false;
//     } catch (error) {
//       console.error('Error validating phone:', error);
//       return false;
//     }
//   };

//   // البحث عن الدوبليكات عند ترك حقل التليفون
//   const handlePhoneBlur = async () => {
//     // التحقق من صحة الرقم
//     if (!value) {
//       setError('Phone number is required');
//       return;
//     }

//     const phoneNumber = parsePhoneNumberFromString(value);
//     if (phoneNumber && phoneNumber.isValid()) {
//       setError('');
//     } else {
//       // setError('Please enter a valid phone number');
//       setError('');

//       return;
//     }

//     // التحقق من الدوبليكات بعد التأكد من صحة الرقم
//     const cleanPhoneWithoutPlus = cleanPhoneNumber(value);
//     if (cleanPhoneWithoutPlus && cleanPhoneWithoutPlus.length >= 5) {
//       await checkPhoneDuplicate(cleanPhoneWithoutPlus);
//     }
//   };

//   const handlePhone2Change = (newValue) => {
//     setphonenumber2(newValue);
//     setErrorphonenumber2('');
//   };

//   const handlewhatsappnumberChange = (newValue) => {
//     setwhatsappnumber(newValue);
//     setwhatsappnumbererror('');
//   };

//   useEffect(() => {
//     setselectedcountry(countryName);
//   }, [countryName]);

//   const handleBlur = () => {
//     if (!value) {
//       setError('Phone number is required');
//       return;
//     }

//     const phoneNumber = parsePhoneNumberFromString(value);
//     if (phoneNumber && phoneNumber.isValid()) {
//       setError('');
//     } else {
//       // setError('Please enter a valid phone number');
//       setError('-');
//     }
//   };

//   const handleBlurphonenumber2 = () => {
//     if (phonenumber2) {
//       const phoneNumber2 = parsePhoneNumberFromString(phonenumber2);
//       if (phoneNumber2 && phoneNumber2.isValid()) {
//         setErrorphonenumber2('');
//       } else {
//         // setErrorphonenumber2('Please enter a valid phone number 2');
//         setErrorphonenumber2('-');
//       }
//     }
//   };

//   const handleBlurwhatsappnumber = () => {
//     if (whatsappnumber) {
//       const whatsappNumber = parsePhoneNumberFromString(whatsappnumber);
//       if (whatsappNumber && whatsappNumber.isValid()) {
//         setwhatsappnumbererror('');
//       } else {
//         // setwhatsappnumbererror('Please enter a valid whatsapp number');
//         setwhatsappnumbererror('-');
//       }
//     }
//   };

//   //date
//   const [date, setDate] = useState('');
//   const [dateonly, setDateonly] = useState('');

//   useEffect(() => {
//     //date and time
//     const today = new Date();
//     const formattedDateandtime = today.toLocaleDateString();
//     setDate(formattedDateandtime);

//     //date only
//     const todaydayonly = new Date();
//     const formattedDateonly = `${todaydayonly.getFullYear()}-${(todaydayonly.getMonth() + 1)
//       .toString()
//       .padStart(2, '0')}-${todaydayonly.getDate().toString().padStart(2, '0')}`;
//     setDateonly(formattedDateonly);
//   }, []);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       const today = new Date();
//       setDate(today.toLocaleDateString());
//     }, 86400000);

//     return () => clearInterval(interval);
//   }, []);

//   //state of fields
//   const [name, setName] = useState('');
//   const [email, setEmail] = useState('');
//   const [note, setNote] = useState('');
//   const [project, setproject] = useState('');
//   const [salesdata, setsalesdata] = useState('');
//   const [loading, setloading] = useState(false);
//   const [stage, setstage] = useState('');
//   const [Channal, setchannal] = useState('');
//   const [Communicationway, setcommunicationwat] = useState('');
//   const [budget, setbudget] = useState(0);
//   const [checked, setChecked] = useState(true);
//   const [Leedtype, setLeedtype] = useState('');
//   const [campaignid, setcampaignid] = useState('');
//   const [jobDescription, setJobDescription] = useState('');
//   const [selectedFcmToken, setSelectedFcmToken] = useState(null);
//   const [selectedSalesName, setSelectedSalesName] = useState('');

//   // state لتحميل البيانات
//   const [isLoading, setIsLoading] = useState(false);
//   const [dataLoaded, setDataLoaded] = useState(false);

//   const handleChange = (event) => {
//     setChecked(event.target.checked);
//   };

//   useEffect(() => {
//     if (checked === true) {
//       setLeedtype('Fresh');
//     } else {
//       setLeedtype('Cold');
//     }
//   }, [checked]);

//   //on changes event of all fields
//   const onjobdescriptionchange = (e) => {
//     setJobDescription(e.target.value);
//   };
//   const onnamechange = (e) => {
//     setName(e.target.value);
//   };

//   const onemailchange = (e) => {
//     setEmail(e.target.value);
//   };

//   const oncampaignidchange = (e) => {
//     setcampaignid(e.target.value);
//   };

//   const onprojectchange = (e) => {
//     setproject(e.target.value);
//   };
//   const onnotechange = (e) => {
//     setNote(e.target.value);
//   };

//   const onsaleschange = (e) => {
//     setsalesdata(e.target.value);
//     const selectedSales = salesData.find((s) => s._id === e.target.value);
//     const fcmToken = selectedSales?.userlog?.fcmToken;
//     const salesName = selectedSales?.name || '';

//     setSelectedFcmToken(fcmToken || null);
//     setSelectedSalesName(salesName);
//   };

//   useEffect(() => {
//     if (selectedFcmToken) {
//       // console.log("🔒 Saved fcmToken:", selectedFcmToken);
//       // console.log("Selected Sales Name:", selectedSalesName);
//     }
//   }, [selectedFcmToken, selectedSalesName]);

//   const onstagechange = (e) => {
//     setstage(e.target.value);
//   };

//   const onchannalchange = (e) => {
//     setchannal(e.target.value);
//   };

//   const oncommunicationwaychange = (e) => {
//     setcommunicationwat(e.target.value);
//   };

//   const onbudgetchange = (e) => {
//     setbudget(e.target.value);
//   };

//   //===================================================
//   //================================================sales filed

//   // دالة لتحميل البيانات من Redux
//   const loadFormData = async () => {
//     if (!dataLoaded) {
//       setIsLoading(true);
//       try {
//         await Promise.all([
//           dispatch(GetAll_stage_Data()),
//           dispatch(GetAllchannalData()),
//           dispatch(GetCommunicationwayData()),
//           dispatch(GetAllCampainData()),
//           dispatch(GetallProjectsdata()),
//           dispatch(Get_All_Sales_Action()),
//         ]);
//         setDataLoaded(true);
//       } catch (error) {
//         console.error('Error loading form data:', error);
//       } finally {
//         setIsLoading(false);
//       }
//     }
//   };

//   useEffect(() => {
//     loadFormData();
//   }, [dispatch]);

//   const resgetallstages = useSelector((state) => state.Allstages.stage);
//   const resgetallchannal = useSelector((state) => state.AllChannalRoot.channal);
//   const resgetallcommunicationway = useSelector(
//     (state) => state.AllCommunicationway.communicationway,
//   );
//   const resgetcampaindata = useSelector((state) => state.AllCampaign.campaign);

//   let res_getallstages_array = Array.isArray(resgetallstages?.data) ? resgetallstages.data : [];
//   let res_getallchannal_array = Array.isArray(resgetallchannal?.data) ? resgetallchannal.data : [];
//   let res_getallcommunicationway_array = Array.isArray(resgetallcommunicationway?.data)
//     ? resgetallcommunicationway.data
//     : [];
//   let res_get_campaign_data_array = Array.isArray(resgetcampaindata?.data)
//     ? resgetcampaindata.data
//     : [];

//   const ressales = useSelector((state) => state.AllSales.sales);

//   let salesData = [];

//   if (ressales?.data) {
//     salesData = ressales.data
//       .filter(
//         (sale) =>
//           ![
//             'Default',
//             'Default M',
//             'Default T',
//             'Default S',
//             'Developer',
//             'Deveolper',
//             'Dev',
//           ].includes(sale.name),
//       )
//       .sort((a, b) => {
//         if (a.name === 'No Sales') return -1;
//         if (b.name === 'No Sales') return 1;
//         return 0;
//       });
//   } else {
//     salesData = [];
//   }

//   // الحصول على بيانات المستخدم الحالي
//   const getCurrentUser = () => {
//     try {
//       const userData = localStorage.getItem('user');
//       if (!userData) return null;

//       const parsedUser = JSON.parse(userData);
//       // تحقق من هيكل البيانات
//       if (parsedUser?.data?._id) {
//         return parsedUser;
//       } else if (parsedUser?._id) {
//         // إذا كان الهيكل مختلفًا
//         return { data: parsedUser };
//       }
//       return null;
//     } catch (error) {
//       console.error('Error getting current user:', error);
//       return null;
//     }
//   };

//   const onSubmit = async (e) => {
//     e.preventDefault();

//     // التحقق من وجود المستخدم
//     const currentUser = getCurrentUser();
//     if (!currentUser || !currentUser.data || !currentUser.data._id) {
//       Notify('error', 'User session expired. Please login again.', 'Error Message');
//       return;
//     }

//     // التحقق الأساسي من الحقول
//     if (name === '') {
//       Notify('error', 'Name is Required ', 'Error Message');
//       return;
//     } else if (value === '') {
//       Notify('error', 'Phone is Required ', 'Error Message');
//       return;
//     } else if (Channal === '') {
//       Notify('error', 'Channel is Required ', 'error');
//       return;
//     } else if (Leedtype === '') {
//       Notify('error', 'Leed Type is Required ', 'error');
//       return;
//     } else if (campaignid === '') {
//       Notify('error', 'Campaign is Required ', 'error');
//       return;
//     } else {
//       // التحقق من الدوبليكات قبل الإرسال
//       const isDuplicate = await validatePhoneBeforeSubmit();

//       if (isDuplicate) {
//         setIsPhoneDuplicate(true);

//         // ✅ بناء رسالة الخطأ بناءً على صلاحية المستخدم
//         let errorMessage = `This phone number is already registered!\n`;
//         errorMessage += `Lead: ${duplicateLeadInfo?.leadName || 'Unknown'}\n`;

//         // ⭐⭐ الشرط: لو المستخدم Admin أو Marketer يظهر اسم الـ Sales
//         if (userlogin?.data?.role === 'Admin' || userlogin?.data?.role === 'Marketer') {
//           errorMessage += `Assigned to: ${duplicateLeadInfo?.salesName || 'No Sales'}\n`;
//         }

//         errorMessage += `Date Added: ${duplicateLeadInfo?.dateAdded || 'Unknown'}`;

//         Notify('warning', errorMessage, 'Duplicate Lead Detected');
//         return;
//       }

//       setSubmitLoading(true);
//       const isAssignable =
//         userlogin?.data?.role === 'Admin' || userlogin?.data?.role === 'Marketer';

//       // تنظيف الأرقام قبل الإرسال
//       const cleanPhoneValue = cleanPhoneNumber(value);
//       const cleanPhone2Value = cleanPhoneNumber(phonenumber2);
//       const cleanWhatsappValue = cleanPhoneNumber(whatsappnumber);

//       try {
//         console.log('🚀 Starting submit process...');

//         // إعداد البيانات للإرسال
//         const leadData = {
//           name: name,
//           email: email,
//           phone: '+' + value,
//           project: project,
//           sales: salesdata,
//           notes: note,
//           date: Date.now(),
//           stage: stage,
//           chanel: Channal,
//           communicationway: Communicationway,
//           leedtype: Leedtype,
//           // budget: budget,
//           budget: budget === '' || budget === undefined || budget === null ? 0 : budget,

//           dayonly: dateonly,
//           last_stage_date_updated: dateonly,
//           lastdateassign: new Date().toLocaleString(),
//           lastcommentdate: '-',
//           addby: currentUser.data._id,
//           updatedby: currentUser.data._id,
//           campaign: campaignid,
//             campaignRedirectLink: campaignRedirectLink || '',

//           unit_price: 0,
//           whatsappnumber: cleanWhatsappValue,
//           phonenumber2: cleanPhone2Value,
//           jobdescription: jobDescription,
//           assign: isAssignable ? true : false,
//           // ========== ⭐⭐ NEW: إضافة الأسئلة ==========
//           question1_text: questions[0]?.question || '',
//           question1_answer: questions[0]?.answer || '',
//           question2_text: questions[1]?.question || '',
//           question2_answer: questions[1]?.answer || '',
//           question3_text: questions[2]?.question || '',
//           question3_answer: questions[2]?.answer || '',
//           question4_text: questions[3]?.question || '',
//           question4_answer: questions[3]?.answer || '',
//           question5_text: questions[4]?.question || '',
//           question5_answer: questions[4]?.answer || '',
//         };

//         console.log('📤 Sending lead data to Redux action:', leadData);

//         // استدعاء الـ Redux action
//         const actionResult = await dispatch(InsertuserData(leadData));

//         console.log('🎯 Action result:', actionResult);

//         // إذا كان هناك خطأ مباشر من الـ action
//         if (actionResult?.error) {
//           throw actionResult.error;
//         }

//         setSubmitLoading(false);
//       } catch (error) {
//         console.error('❌ Error in onSubmit:', error);

//         // معالجة أخطاء الدوبليكات من الباك إند
//         if (error?.response?.status === 400) {
//           const errorData = error.response.data;
//           setIsPhoneDuplicate(true);

//           // استخدام الخصائص الصحيحة من الـ error response
//           setDuplicateLeadInfo({
//             leadName: errorData.leadname || name || 'Unknown',
//             salesName: errorData.salesname || 'Not assigned',
//             leadId: errorData.leadId,
//             dateAdded: errorData.existingLead?.date
//               ? new Date(errorData.existingLead.date).toLocaleDateString()
//               : 'Unknown',
//           });

//           // ✅ بناء رسالة الخطأ بناءً على صلاحية المستخدم
//           let errorMessage = `${errorData.message || 'Phone number already exists'}\n`;
//           errorMessage += `Lead: ${errorData.leadname || name || 'Unknown'}\n`;

//           // ⭐⭐ الشرط: لو المستخدم Admin أو Marketer يظهر اسم الـ Sales
//           if (userlogin?.data?.role === 'Admin' || userlogin?.data?.role === 'Marketer') {
//             errorMessage += `Assigned to: ${errorData.salesname || 'Not assigned'}\n`;
//           }

//           if (errorData.leadId) {
//             errorMessage += `Lead ID: ${errorData.leadId}`;
//           }

//           Notify('error', errorMessage, 'Duplicate Lead');
//         } else {
//           Notify(
//             'error',
//             error?.response?.data?.message || error?.message || 'Failed to add lead',
//             'Error Message',
//           );
//         }
//         setSubmitLoading(false);
//       }
//     }
//   };

//   const res = useSelector((state) => state.Allusers.Get_users);

//   // دالة reset للقيم مع حفظ رمز دولة الإمارات فقط
//   const resetForm = () => {
//     setName('');
//     setEmail('');
//     setNote('');
//     setproject('');
//     setsalesdata('');
//     setchannal('');
//     setstage('');
//     setcommunicationwat('');
//     setcampaignid('');
//       setCampaignRedirectLink('');
 
//     setJobDescription('');
//     setbudget(0);
//     setChecked(true);
//     setLeedtype('Fresh');
//     setIsPhoneDuplicate(false);
//     setDuplicateLeadInfo(null);
//     setError('');
//     setErrorphonenumber2('');
//     setwhatsappnumbererror('');
//     setCleanPhoneForSearch('');

//     // ========== ⭐⭐ NEW: إعادة تعيين الأسئلة ==========
//     setQuestions([{ id: 1, question: '', answer: '' }]);
//     setNextQuestionId(2);

//     // إعادة تعيين حقول التليفون لرمز دولة الإمارات فقط
//     resetPhoneFields();

//     // إعادة تحميل البيانات
//     setDataLoaded(false);
//     loadFormData();
//     window.location.reload(false);
//   };

//   // دالة لإعادة تحميل البيانات
//   const refreshFormData = () => {
//     setDataLoaded(false);
//     loadFormData();
//     window.location.reload(false);
//     // Notify('suc', 'Form data refreshed successfully', 'Refresh');
//   };

//   // التعامل مع الـ response من Redux
//   useEffect(() => {
//     console.log('🔄 useEffect triggered with loading:', loading, 'res:', res);

//     if (loading === false && res) {
//       console.log('🎯 Response من الـ Redux Store:');
//       console.log('📊 Status:', res.status);
//       console.log('📦 Full Response from Redux:', res);

//       // التحقق إذا كان هناك خطأ
//       if (res?.data?.status >= 400) {
//         console.error('❌ Error Response:', res);
//         const errorMessage = res.data?.message || 'Failed to add lead';
//         const leadId = res?.data?.data?.leadId;

//         setIsPhoneDuplicate(true);

//         // ✅ بناء رسالة الخطأ بناءً على صلاحية المستخدم
//         let errorMsg = `${errorMessage}\n`;
//         errorMsg += `Lead: ${res?.data?.leadname || 'Unknown'}\n`;

//         // ⭐⭐ الشرط: لو المستخدم Admin أو Marketer يظهر اسم الـ Sales
//         if (userlogin?.data?.role === 'Admin' || userlogin?.data?.role === 'Marketer') {
//           errorMsg += `Assigned to: ${res.data?.salesname || 'Not assigned'}\n`;
//         }

//         if (leadId) {
//           errorMsg += `Lead ID: ${leadId}`;
//         }

//         Notify('error', errorMsg, 'Duplicate Lead');
//         setloading(false);
//         return;
//       }

//       // تحقق من هيكل البيانات المختلفة
//       if (res?.data?.data?.lead) {
//         // الحالة: data.lead موجود (الهيكل الجديد)
//         const lead = res?.data?.data?.lead;
//         console.log('✅ Lead Added Successfully!');
//         console.log('👤 Lead Data:', lead);
//         console.log('🆔 Lead ID:', lead._id);
//         console.log('📞 Phone:', lead.phone);
//         console.log('👤 Name:', lead.name);
//         console.log('🎯 Sales:', lead.sales?.name);
//         console.log('📅 Date:', lead.date);
//         console.log('🔍 Is Duplicate:', res.data.isDuplicate);
//         console.log('📊 Total Submissions:', res.data.totalSubmissions);

//         // إشعار بنجاح الإضافة مع تفاصيل
//         Notify(
//           'success',
//           `✅ Lead added successfully! 
//           Name: ${lead.name}
//           // Phone: ${lead.phone}
//           Assigned to: ${lead.sales?.name || 'Not Assigned'}
//           // Lead ID: ${lead._id}`,
//           'Success Message',
//         );

//         resetForm();

//         // إعادة تحميل الصفحة بعد 2 ثانية
//         setTimeout(() => {
//           window.location.reload();
//         }, 2000);
//       } else if (res.data?._id) {
//         // الحالة: data مباشرة (الهيكل القديم)
//         console.log('✅ Lead Added Successfully!');
//         console.log('👤 Lead Data:', res.data);
//         console.log('🆔 Lead ID:', res.data._id);
//         console.log('📞 Phone:', res.data.phone);
//         console.log('👤 Name:', res.data.name);
//         console.log('🎯 Sales:', res.data.sales?.name);

//         Notify(
//           'success',
//           `✅ Lead added successfully! 
//           Name: ${res.data.name}
//           Phone: ${res.data.phone}
//           Assigned to: ${res.data.sales?.name || 'Not Assigned'}
//           Lead ID: ${res.data._id}`,
//           'Success Message',
//         );

//         resetForm();

//         setTimeout(() => {
//           window.location.reload();
//         }, 2000);
//       } else if (res.payload?.data?.lead) {
//         // الحالة: من payload.data.lead
//         const lead = res.payload.data.lead;
//         console.log('✅ Lead Added Successfully!');
//         console.log('👤 Lead Data from payload:', lead);

//         Notify(
//           'success',
//           `✅ Lead added successfully! 
//           Name: ${lead.name}
//           Phone: ${lead.phone}
//           Lead ID: ${lead._id}`,
//           'Success Message',
//         );

//         resetForm();

//         setTimeout(() => {
//           window.location.reload();
//         }, 2000);
//       }

//       setloading(false);
//     } else if (res && res.error) {
//       // معالجة حالة الخطأ من Redux
//       console.error('❌ Error from Redux:', res.error);
//       const errorMessage = res.error?.response?.data?.message || 'Failed to add lead';
//       const leadId = res.error?.response?.data?.leadId;

//       setIsPhoneDuplicate(true);

//       // ✅ بناء رسالة الخطأ بناءً على صلاحية المستخدم
//       let errorMsg = `${errorMessage}\n`;
//       errorMsg += `Lead: ${res.error?.response?.data?.leadname || 'Unknown'}\n`;

//       // ⭐⭐ الشرط: لو المستخدم Admin أو Marketer يظهر اسم الـ Sales
//       if (userlogin?.data?.role === 'Admin' || userlogin?.data?.role === 'Marketer') {
//         errorMsg += `Assigned to: ${res.error?.response?.data?.salesname || 'Not assigned'}\n`;
//       }

//       if (leadId) {
//         errorMsg += `Lead ID: ${leadId}`;
//       }

//       Notify('error', errorMsg, 'Duplicate Lead');
//       setloading(false);
//       setSubmitLoading(false);
//     } else if (loading === false && !res) {
//       console.log('⚠️ No response received');
//     }
//   }, [loading, res]);

//   const resProjects = useSelector((state) => state.AllProjects.Projects);

//   let Allprojects = [];
//   if (resProjects && resProjects.data) {
//     Allprojects = resProjects.data;
//   } else {
//     Allprojects = [];
//   }

//   // تحديد الراوت المناسب
//   const getHomeRoute = () => {
//     if (!userlogin?.data?.role) return '/';

//     switch (userlogin.data.role) {
//       case 'Admin':
//         return '/AllLeadsForAdmin';
//       case 'Sales':
//         return '/AllLeadsForSales';
//       case 'Team Leader':
//         return '/AllLeadsForTeamLeader';
//       case 'Manager':
//         return '/LeadsForManagers';
//       case 'Marketer':
//         return '/ALLLeadsForMarketer';
//       default:
//         return '/';
//     }
//   };

//   const homeRoute = getHomeRoute();

//   // إصلاح الـ Autocomplete في sales
//   const getSalesOptions = () => {
//     if (!userlogin?.data?.role) return salesData;

//     if (userlogin.data.role === 'Sales') {
//       const currentUserSales = salesData.find(
//         (sales) => sales?.userlog?.email === userlogin?.data?.email,
//       );
//       if (currentUserSales) {
//         if (!salesdata) {
//           setsalesdata(currentUserSales._id);
//         }
//         return [currentUserSales];
//       }
//       return [];
//     } else if (userlogin.data.role === 'Team Leader') {
//       return salesData.filter((sales) => sales?.teamleader?._id === userlogin?.data?._id);
//     } else {
//       return salesData;
//     }
//   };

//   const salesOptions = getSalesOptions();

//   // ⭐⭐ دالة لعرض رسالة الدوبليكات بناءً على صلاحية المستخدم
//   const renderDuplicateMessage = () => {
//     if (!isPhoneDuplicate || !duplicateLeadInfo) return null;

//     const isAdminOrMarketer =
//       userlogin?.data?.role === 'Admin' || userlogin?.data?.role === 'Marketer';

//     return (
//       <div
//         style={{
//           background: '#fff3cd',
//           border: '1px solid #ffc107',
//           borderRadius: '8px',
//           padding: '16px',
//           marginTop: '12px',
//           color: '#856404',
//         }}
//       >
//         <div
//           style={{
//             display: 'flex',
//             alignItems: 'flex-start',
//             gap: '12px',
//             marginBottom: '12px',
//           }}
//         >
//           <div
//             style={{
//               background: '#ffc107',
//               borderRadius: '50%',
//               width: '24px',
//               height: '24px',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               flexShrink: 0,
//             }}
//           >
//             <span style={{ fontSize: '14px', fontWeight: 'bold' }}>!</span>
//           </div>
//           <div>
//             <h4
//               style={{
//                 margin: 0,
//                 color: '#856404',
//                 fontSize: '14px',
//                 fontWeight: '600',
//               }}
//             >
//               ⚠️ Duplicate Lead Detected!
//             </h4>
//             <p
//               style={{
//                 margin: '4px 0 0 0',
//                 fontSize: '13px',
//                 color: '#856404',
//               }}
//             >
//               This phone number is already registered in the system
//             </p>
//           </div>
//         </div>

//         <div
//           style={{
//             background: '#fff',
//             borderRadius: '6px',
//             padding: '12px',
//             border: '1px solid #ffeaa7',
//           }}
//         >
//           <div
//             style={{
//               display: 'grid',
//               gridTemplateColumns: isAdminOrMarketer ? 'repeat(2, 1fr)' : '1fr',
//               gap: '8px',
//               fontSize: '13px',
//             }}
//           >
//             <div>
//               <strong>Lead Name:</strong>
//               <div>{duplicateLeadInfo.leadName}</div>
//             </div>

//             {/* ⭐⭐ عرض اسم الـ Sales فقط لو المستخدم Admin أو Marketer */}
//             {isAdminOrMarketer && (
//               <div>
//                 <strong>Assigned Sales:</strong>
//                 <div>{duplicateLeadInfo.salesName}</div>
//               </div>
//             )}
//           </div>

//           {duplicateLeadInfo.leadId && (
//             <div
//               style={{
//                 marginTop: '12px',
//                 paddingTop: '12px',
//                 borderTop: '1px dashed #ddd',
//                 fontSize: '12px',
//                 color: '#666',
//               }}
//             >
//               <strong>Lead ID:</strong> {duplicateLeadInfo.leadId}
//               {duplicateLeadInfo.dateAdded && (
//                 <span style={{ marginLeft: '12px' }}>
//                   <strong>Added:</strong> {duplicateLeadInfo.dateAdded}
//                 </span>
//               )}
//             </div>
//           )}
//         </div>

//         <div
//           style={{
//             marginTop: '12px',
//             fontSize: '12px',
//             color: '#666',
//             fontStyle: 'italic',
//           }}
//         >
//           ❌ Cannot add duplicate phone numbers. Please use a different phone number.
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div
//       style={{
//         background: mode === 'dark' ? '#121212' : '#f8fafc',
//         minHeight: '100vh',
//         fontFamily: "'Segoe UI', 'Roboto', sans-serif",
//       }}
//     >
//       <Container className="py-4">
//         <Row style={{ width: '100%' }}>
//           <Col sm={2}></Col>
//           <Col sm={10}>
//             {/* Breadcrumb */}
//             <div className="startpage mb-4">
//               <Link to={homeRoute} style={{ textDecoration: 'none', color: '#102dff' }}>
//                 <span style={{ fontWeight: '600' }}>Home</span>
//               </Link>
//               <KeyboardDoubleArrowRightIcon style={{ fontSize: '18px', margin: '0 8px' }} />
//               <span style={{ color: mode === 'dark' ? '#aaa' : '#666', fontWeight: '500' }}>
//                 Add New Lead
//               </span>
//             </div>

//             {/* Header Card */}
//             <div
//               style={{
//                 background: mode === 'dark' ? '#1e1e1e' : '#ffffff',
//                 borderRadius: '12px',
//                 padding: '24px',
//                 marginBottom: '24px',
//                 boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
//                 border: mode === 'dark' ? '1px solid #333' : '1px solid #e9ecef',
//               }}
//             >
//               <div
//                 style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
//               >
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
//                   <AddIcon
//                     style={{
//                       color: '#102dff',
//                       background: 'rgba(16, 45, 255, 0.1)',
//                       borderRadius: '8px',
//                       padding: '8px',
//                     }}
//                   />
//                   <div>
//                     <h3
//                       style={{
//                         margin: 0,
//                         color: mode === 'dark' ? '#fff' : '#2c3e50',
//                         fontWeight: '600',
//                       }}
//                     >
//                       Add New Lead
//                     </h3>
//                     <p
//                       style={{
//                         margin: '4px 0 0 0',
//                         color: mode === 'dark' ? '#aaa' : '#666',
//                         fontSize: '14px',
//                       }}
//                     >
//                       Fill in the lead details below. Fields marked with * are required.
//                     </p>
//                   </div>
//                 </div>
//                 <button
//                   onClick={refreshFormData}
//                   disabled={isLoading}
//                   style={{
//                     padding: '8px 16px',
//                     background: '#102dff',
//                     border: 'none',
//                     borderRadius: '6px',
//                     color: '#fff',
//                     fontSize: '13px',
//                     fontWeight: '500',
//                     cursor: 'pointer',
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '6px',
//                     transition: 'all 0.3s',
//                   }}
//                   onMouseOver={(e) => {
//                     if (!isLoading) {
//                       e.target.style.background = '#102dff';
//                       e.target.style.transform = 'translateY(-1px)';
//                     }
//                   }}
//                   onMouseOut={(e) => {
//                     if (!isLoading) {
//                       e.target.style.background = '#102dff';
//                       e.target.style.transform = 'translateY(0)';
//                     }
//                   }}
//                 >
//                   {isLoading ? (
//                     <>
//                       <CircularProgress size={14} style={{ color: 'white' }} />
//                       Loading...
//                     </>
//                   ) : (
//                     <>
//                       {/* <span>🔄</span> */}
//                       Refresh Data
//                     </>
//                   )}
//                 </button>
//               </div>
//             </div>

//             {/* Main Form Card */}
//             <div
//               style={{
//                 background: mode === 'dark' ? '#1e1e1e' : '#ffffff',
//                 borderRadius: '12px',
//                 padding: '32px',
//                 boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
//                 border: mode === 'dark' ? '1px solid #333' : '1px solid #e9ecef',
//               }}
//             >
//               {/* Form Fields Grid */}
//               <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '24px' }}>
//                 {/* Name Field */}
//                 <div>
//                   <label
//                     style={{
//                       display: 'block',
//                       marginBottom: '8px',
//                       color: mode === 'dark' ? '#ddd' : '#495057',
//                       fontWeight: '500',
//                       fontSize: '14px',
//                     }}
//                   >
//                     Full Name *
//                   </label>
//                   <input
//                     onChange={onnamechange}
//                     value={name}
//                     style={{
//                       width: '100%',
//                       padding: '12px 16px',
//                       borderRadius: '8px',
//                       border: `1px solid ${mode === 'dark' ? '#444' : '#ddd'}`,
//                       background: mode === 'dark' ? '#2d2d2d' : '#fff',
//                       color: mode === 'dark' ? '#fff' : '#333',
//                       fontSize: '14px',
//                       transition: 'all 0.3s',
//                       outline: 'none',
//                     }}
//                     type="text"
//                     placeholder="Enter full name"
//                     onFocus={(e) => (e.target.style.borderColor = '#102dff')}
//                     onBlur={(e) => (e.target.style.borderColor = mode === 'dark' ? '#444' : '#ddd')}
//                   />
//                 </div>

//                 {/* Email Field */}
//                 <div>
//                   <label
//                     style={{
//                       display: 'block',
//                       marginBottom: '8px',
//                       color: mode === 'dark' ? '#ddd' : '#495057',
//                       fontWeight: '500',
//                       fontSize: '14px',
//                     }}
//                   >
//                     Email Address
//                   </label>
//                   <input
//                     onChange={onemailchange}
//                     value={email}
//                     style={{
//                       width: '100%',
//                       padding: '12px 16px',
//                       borderRadius: '8px',
//                       border: `1px solid ${mode === 'dark' ? '#444' : '#ddd'}`,
//                       background: mode === 'dark' ? '#2d2d2d' : '#fff',
//                       color: mode === 'dark' ? '#fff' : '#333',
//                       fontSize: '14px',
//                       transition: 'all 0.3s',
//                       outline: 'none',
//                     }}
//                     type="email"
//                     placeholder="Enter email address"
//                     onFocus={(e) => (e.target.style.borderColor = '#102dff')}
//                     onBlur={(e) => (e.target.style.borderColor = mode === 'dark' ? '#444' : '#ddd')}
//                   />
//                 </div>

//                 {/* Phone Field - مع رسالة الدوبليكات */}
//                 <div>
//                   <label
//                     style={{
//                       display: 'block',
//                       marginBottom: '8px',
//                       color: mode === 'dark' ? '#ddd' : '#495057',
//                       fontWeight: '500',
//                       fontSize: '14px',
//                     }}
//                   >
//                     Phone Number *
//                   </label>
//                   <div style={{ position: 'relative' }}>
//                     <PhoneInput
//                       country={'ae'}
//                       value={value}
//                       onChange={handlePhoneChange}
//                       onBlur={handlePhoneBlur}
//                       preferredCountries={['ae', 'us', 'gb']}
//                       inputStyle={{
//                         width: '100%',
//                         height: '48px',
//                         background: mode === 'dark' ? '#2d2d2d' : '#fff',
//                         color: mode === 'dark' ? '#fff' : '#333',
//                         border: `1px solid ${mode === 'dark' ? '#444' : '#ddd'}`,
//                         borderRadius: '8px',
//                         fontSize: '14px',
//                         paddingLeft: '50px',
//                       }}
//                       buttonStyle={{
//                         background: mode === 'dark' ? '#2d2d2d' : '#fff',
//                         border: `1px solid ${mode === 'dark' ? '#444' : '#ddd'}`,
//                         borderRadius: '8px 0 0 8px',
//                       }}
//                       dropdownStyle={{
//                         background: mode === 'dark' ? '#2d2d2d' : '#fff',
//                         color: mode === 'dark' ? '#fff' : '#333',
//                       }}
//                     />
//                   </div>

//                   {/* Error Messages */}
//                   {error && (
//                     <p
//                       style={{
//                         color: '#dc3545',
//                         fontSize: '12px',
//                         marginTop: '4px',
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: '4px',
//                       }}
//                     >
//                       {/* ⚠️ {error} */} -
//                     </p>
//                   )}

//                   {/* ⭐⭐ عرض رسالة الدوبليكات بناءً على صلاحية المستخدم */}
//                   {renderDuplicateMessage()}
//                 </div>

//                 {/* Second Phone */}
//                 <div>
//                   <label
//                     style={{
//                       display: 'block',
//                       marginBottom: '8px',
//                       color: mode === 'dark' ? '#ddd' : '#495057',
//                       fontWeight: '500',
//                       fontSize: '14px',
//                     }}
//                   >
//                     Second Phone
//                   </label>
//                   <PhoneInput
//                     country={'ae'}
//                     value={phonenumber2}
//                     onChange={handlePhone2Change}
//                     onBlur={handleBlurphonenumber2}
//                     preferredCountries={['ae', 'us', 'gb']}
//                     inputStyle={{
//                       width: '100%',
//                       height: '48px',
//                       background: mode === 'dark' ? '#2d2d2d' : '#fff',
//                       color: mode === 'dark' ? '#fff' : '#333',
//                       border: `1px solid ${mode === 'dark' ? '#444' : '#ddd'}`,
//                       borderRadius: '8px',
//                       fontSize: '14px',
//                       paddingLeft: '50px',
//                     }}
//                   />
//                   {Errorphonenumber2 && (
//                     <p
//                       style={{
//                         color: '#dc3545',
//                         fontSize: '12px',
//                         marginTop: '4px',
//                       }}
//                     >
//                       {/* ⚠️ {Errorphonenumber2} */} -
//                     </p>
//                   )}
//                 </div>

//                 {/* WhatsApp */}
//                 <div>
//                   <label
//                     style={{
//                       display: 'block',
//                       marginBottom: '8px',
//                       color: mode === 'dark' ? '#ddd' : '#495057',
//                       fontWeight: '500',
//                       fontSize: '14px',
//                     }}
//                   >
//                     WhatsApp Number
//                   </label>
//                   <PhoneInput
//                     country={'ae'}
//                     value={whatsappnumber}
//                     onChange={handlewhatsappnumberChange}
//                     onBlur={handleBlurwhatsappnumber}
//                     preferredCountries={['ae', 'us', 'gb']}
//                     inputStyle={{
//                       width: '100%',
//                       height: '48px',
//                       background: mode === 'dark' ? '#2d2d2d' : '#fff',
//                       color: mode === 'dark' ? '#fff' : '#333',
//                       border: `1px solid ${mode === 'dark' ? '#444' : '#ddd'}`,
//                       borderRadius: '8px',
//                       fontSize: '14px',
//                       paddingLeft: '50px',
//                     }}
//                   />
//                   {whatsappnumbererror && (
//                     <p
//                       style={{
//                         color: '#dc3545',
//                         fontSize: '12px',
//                         marginTop: '4px',
//                       }}
//                     >
//                       {/* ⚠️ {whatsappnumbererror} */} -
//                     </p>
//                   )}
//                 </div>

//                 {/* Project */}
//                 <div>
//                   <label
//                     style={{
//                       display: 'block',
//                       marginBottom: '8px',
//                       color: mode === 'dark' ? '#ddd' : '#495057',
//                       fontWeight: '500',
//                       fontSize: '14px',
//                     }}
//                   >
//                     Project *
//                   </label>
//                   <FormControl fullWidth>
//                     <Autocomplete
//                       key={dataLoaded ? 'projects-loaded' : 'projects-loading'}
//                       options={Allprojects || []}
//                       getOptionLabel={(option) => option?.name || ''}
//                       value={Allprojects?.find((proj) => proj._id === project) || null}
//                       onChange={(event, newValue) => {
//                         setproject(newValue ? newValue._id : '');
//                       }}
//                       loading={isLoading}
//                       renderInput={(params) => (
//                         <TextField
//                           {...params}
//                           placeholder="Select project"
//                           variant="outlined"
//                           size="small"
//                           sx={{
//                             '& .MuiOutlinedInput-root': {
//                               background: mode === 'dark' ? '#2d2d2d' : '#fff',
//                               color: mode === 'dark' ? '#fff' : '#333',
//                             },
//                             '& .MuiInputLabel-root': {
//                               color: mode === 'dark' ? '#aaa' : '#666',
//                             },
//                           }}
//                         />
//                       )}
//                     />
//                   </FormControl>
//                 </div>

//                 {/* Sales */}
//                 <div>
//                   <label
//                     style={{
//                       display: 'block',
//                       marginBottom: '8px',
//                       color: mode === 'dark' ? '#ddd' : '#495057',
//                       fontWeight: '500',
//                       fontSize: '14px',
//                     }}
//                   >
//                     Sales *
//                   </label>
//                   <FormControl fullWidth disabled={userlogin?.data?.role === 'Sales'}>
//                     <Autocomplete
//                       key={dataLoaded ? 'sales-loaded' : 'sales-loading'}
//                       options={salesOptions || []}
//                       getOptionLabel={(option) => option?.name || ''}
//                       value={salesData.find((sales) => sales._id === salesdata) || null}
//                       onChange={(event, newValue) => {
//                         setsalesdata(newValue ? newValue._id : '');
//                       }}
//                       loading={isLoading}
//                       renderInput={(params) => (
//                         <TextField
//                           {...params}
//                           placeholder="Select sales"
//                           variant="outlined"
//                           size="small"
//                           sx={{
//                             '& .MuiOutlinedInput-root': {
//                               background: mode === 'dark' ? '#2d2d2d' : '#fff',
//                               color: mode === 'dark' ? '#fff' : '#333',
//                             },
//                           }}
//                         />
//                       )}
//                     />
//                   </FormControl>
//                 </div>

//                 {/* Campaign */}
//                 <div>
//                   <label
//                     style={{
//                       display: 'block',
//                       marginBottom: '8px',
//                       color: mode === 'dark' ? '#ddd' : '#495057',
//                       fontWeight: '500',
//                       fontSize: '14px',
//                     }}
//                   >
//                     Campaign *
//                   </label>
//                   <FormControl fullWidth>
//                     <Autocomplete
//                       key={dataLoaded ? 'campaign-loaded' : 'campaign-loading'}
//                       options={res_get_campaign_data_array || []}
//                       getOptionLabel={(option) => option?.CampainName || ''}
//                       value={
//                         res_get_campaign_data_array?.find((item) => item._id === campaignid) || null
//                       }
//                       onChange={(event, newValue) => {
//                         setcampaignid(newValue ? newValue._id : '');
//                       }}
//                       loading={isLoading}
//                       renderInput={(params) => (
//                         <TextField
//                           {...params}
//                           placeholder="Select campaign"
//                           variant="outlined"
//                           size="small"
//                           sx={{
//                             '& .MuiOutlinedInput-root': {
//                               background: mode === 'dark' ? '#2d2d2d' : '#fff',
//                               color: mode === 'dark' ? '#fff' : '#333',
//                             },
//                           }}
//                         />
//                       )}
//                     />
//                   </FormControl>
//                 </div>



   

//                 {/* Channel */}
//                 <div>
//                   <label
//                     style={{
//                       display: 'block',
//                       marginBottom: '8px',
//                       color: mode === 'dark' ? '#ddd' : '#495057',
//                       fontWeight: '500',
//                       fontSize: '14px',
//                     }}
//                   >
//                     Channel *
//                   </label>
//                   <FormControl fullWidth>
//                     <Autocomplete
//                       key={dataLoaded ? 'channel-loaded' : 'channel-loading'}
//                       options={res_getallchannal_array || []}
//                       getOptionLabel={(option) => option?.name || ''}
//                       value={res_getallchannal_array?.find((item) => item._id === Channal) || null}
//                       onChange={(event, newValue) => {
//                         setchannal(newValue ? newValue._id : '');
//                       }}
//                       loading={isLoading}
//                       renderInput={(params) => (
//                         <TextField
//                           {...params}
//                           placeholder="Select channel"
//                           variant="outlined"
//                           size="small"
//                           sx={{
//                             '& .MuiOutlinedInput-root': {
//                               background: mode === 'dark' ? '#2d2d2d' : '#fff',
//                               color: mode === 'dark' ? '#fff' : '#333',
//                             },
//                           }}
//                         />
//                       )}
//                     />
//                   </FormControl>
//                 </div>

//                 {/* Communication Way */}
//                 <div>
//                   <label
//                     style={{
//                       display: 'block',
//                       marginBottom: '8px',
//                       color: mode === 'dark' ? '#ddd' : '#495057',
//                       fontWeight: '500',
//                       fontSize: '14px',
//                     }}
//                   >
//                     Communication Way
//                   </label>
//                   <FormControl fullWidth>
//                     <Autocomplete
//                       key={dataLoaded ? 'commway-loaded' : 'commway-loading'}
//                       options={(res_getallcommunicationway_array || []).slice().sort((a, b) => {
//                         if (a.name === 'No Communication Way') return -1;
//                         if (b.name === 'No Communication Way') return 1;
//                         return 0;
//                       })}
//                       getOptionLabel={(option) => option?.name || ''}
//                       value={
//                         res_getallcommunicationway_array?.find(
//                           (item) => item._id === Communicationway,
//                         ) || null
//                       }
//                       onChange={(event, newValue) => {
//                         setcommunicationwat(newValue ? newValue._id : '');
//                       }}
//                       loading={isLoading}
//                       renderInput={(params) => (
//                         <TextField
//                           {...params}
//                           placeholder="Select communication way"
//                           variant="outlined"
//                           size="small"
//                           sx={{
//                             '& .MuiOutlinedInput-root': {
//                               background: mode === 'dark' ? '#2d2d2d' : '#fff',
//                               color: mode === 'dark' ? '#fff' : '#333',
//                             },
//                           }}
//                         />
//                       )}
//                     />
//                   </FormControl>
//                 </div>


// {
//   userlogin?.data?.role==="Admin"||userlogin?.data?.role==="Marketer"?(
//     <div>
//   <label
//     style={{
//       display: 'block',
//       marginBottom: '8px',
//       color: mode === 'dark' ? '#ddd' : '#495057',
//       fontWeight: '500',
//       fontSize: '14px',
//     }}
//   >
//     Campaign Redirect Link
//     <span
//       style={{
//         fontSize: '11px',
//         color: '#6c757d',
//         marginLeft: '8px',
//         fontWeight: 'normal',
//       }}
//     >
//       (optional)
//     </span>
//   </label>
//   <input
//     onChange={onCampaignRedirectLinkChange}
//     value={campaignRedirectLink}
//     style={{
//       width: '100%',
//       padding: '12px 16px',
//       borderRadius: '8px',
//       border: `1px solid ${mode === 'dark' ? '#444' : '#ddd'}`,
//       background: mode === 'dark' ? '#2d2d2d' : '#fff',
//       color: mode === 'dark' ? '#fff' : '#333',
//       fontSize: '14px',
//       transition: 'all 0.3s',
//       outline: 'none',
//     }}
//     type="url"
//     placeholder="https://example.com/campaign-link"
//     onFocus={(e) => (e.target.style.borderColor = '#102dff')}
//     onBlur={(e) => (e.target.style.borderColor = mode === 'dark' ? '#444' : '#ddd')}
//   />
//   <p
//     style={{
//       fontSize: '11px',
//       color: '#6c757d',
//       marginTop: '4px',
//       marginBottom: 0,
//     }}
//   >
//     🔗 Enter the redirect link for this campaign (optional)
//   </p>
// </div>
//   ):null
// }
             
//                 {/* Job Description */}
//                 <div style={{ gridColumn: 'span 2' }}>
//                   <label
//                     style={{
//                       display: 'block',
//                       marginBottom: '8px',
//                       color: mode === 'dark' ? '#ddd' : '#495057',
//                       fontWeight: '500',
//                       fontSize: '14px',
//                     }}
//                   >
//                     Job Description
//                   </label>
//                   <input
//                     onChange={onjobdescriptionchange}
//                     value={jobDescription}
//                     style={{
//                       width: '100%',
//                       padding: '12px 16px',
//                       borderRadius: '8px',
//                       border: `1px solid ${mode === 'dark' ? '#444' : '#ddd'}`,
//                       background: mode === 'dark' ? '#2d2d2d' : '#fff',
//                       color: mode === 'dark' ? '#fff' : '#333',
//                       fontSize: '14px',
//                       transition: 'all 0.3s',
//                       outline: 'none',
//                     }}
//                     type="text"
//                     placeholder="Enter job description"
//                     onFocus={(e) => (e.target.style.borderColor = '#102dff')}
//                     onBlur={(e) => (e.target.style.borderColor = mode === 'dark' ? '#444' : '#ddd')}
//                   />
//                 </div>

//                 {/* Budget */}
//                 <div>
//                   <label
//                     style={{
//                       display: 'block',
//                       marginBottom: '8px',
//                       color: mode === 'dark' ? '#ddd' : '#495057',
//                       fontWeight: '500',
//                       fontSize: '14px',
//                     }}
//                   >
//                     Budget
//                   </label>
//                   <input
//                     onChange={onbudgetchange}
//                     value={budget}
//                     style={{
//                       width: '100%',
//                       padding: '12px 16px',
//                       borderRadius: '8px',
//                       border: `1px solid ${mode === 'dark' ? '#444' : '#ddd'}`,
//                       background: mode === 'dark' ? '#2d2d2d' : '#fff',
//                       color: mode === 'dark' ? '#fff' : '#333',
//                       fontSize: '14px',
//                       transition: 'all 0.3s',
//                       outline: 'none',
//                     }}
//                     type="number"
//                     placeholder="Enter budget"
//                     onFocus={(e) => (e.target.style.borderColor = '#102dff')}
//                     onBlur={(e) => (e.target.style.borderColor = mode === 'dark' ? '#444' : '#ddd')}
//                   />
//                 </div>

//                 {/* Note */}
//                 <div>
//                   <label
//                     style={{
//                       display: 'block',
//                       marginBottom: '8px',
//                       color: mode === 'dark' ? '#ddd' : '#495057',
//                       fontWeight: '500',
//                       fontSize: '14px',
//                     }}
//                   >
//                     Note
//                   </label>
//                   <input
//                     onChange={onnotechange}
//                     value={note}
//                     style={{
//                       width: '100%',
//                       padding: '12px 16px',
//                       borderRadius: '8px',
//                       border: `1px solid ${mode === 'dark' ? '#444' : '#ddd'}`,
//                       background: mode === 'dark' ? '#2d2d2d' : '#fff',
//                       color: mode === 'dark' ? '#fff' : '#333',
//                       fontSize: '14px',
//                       transition: 'all 0.3s',
//                       outline: 'none',
//                     }}
//                     type="text"
//                     placeholder="Enter note"
//                     onFocus={(e) => (e.target.style.borderColor = '#102dff')}
//                     onBlur={(e) => (e.target.style.borderColor = mode === 'dark' ? '#444' : '#ddd')}
//                   />
//                 </div>

//                 {/* Lead Type */}
//                 <div style={{ gridColumn: 'span 2' }}>
//                   <div
//                     style={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: '16px',
//                       padding: '16px',
//                       background: mode === 'dark' ? '#2d2d2d' : '#f8f9fa',
//                       borderRadius: '8px',
//                       border: `1px solid ${mode === 'dark' ? '#444' : '#ddd'}`,
//                     }}
//                   >
//                     <div>
//                       <label
//                         style={{
//                           color: mode === 'dark' ? '#ddd' : '#495057',
//                           fontWeight: '500',
//                           fontSize: '14px',
//                           marginRight: '12px',
//                         }}
//                       >
//                         Lead Type:
//                       </label>
//                       <span
//                         style={{
//                           color: Leedtype === 'Fresh' ? '#28a745' : '#6c757d',
//                           fontWeight: '600',
//                         }}
//                       >
//                         {Leedtype}
//                       </span>
//                     </div>
//                     <Switch checked={checked} onChange={handleChange} color="primary" />
//                     <div
//                       style={{
//                         fontSize: '13px',
//                         color: mode === 'dark' ? '#aaa' : '#666',
//                       }}
//                     >
//                       {checked ? '🟢 Fresh Lead' : '🔵 Cold Lead'}
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* ========== ⭐⭐ NEW: Questions Section ========== */}
//               {userlogin?.data?.role === 'Admin' || userlogin?.data?.role === 'Marketer' ? (
//                 <div
//                   style={{
//                     marginTop: '32px',
//                     padding: '24px',
//                     background: mode === 'dark' ? '#2d2d2d' : '#f8f9ff',
//                     borderRadius: '12px',
//                     border: `1px solid ${mode === 'dark' ? '#444' : '#e0e0e0'}`,
//                   }}
//                 >
//                   <div
//                     style={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'space-between',
//                       marginBottom: '20px',
//                     }}
//                   >
//                     <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                       <QuestionAnswerIcon style={{ color: '#102dff' }} />
//                       <h4
//                         style={{
//                           margin: 0,
//                           color: mode === 'dark' ? '#fff' : '#333',
//                           fontWeight: '600',
//                           fontSize: '1.1rem',
//                         }}
//                       >
//                         Additional Questions
//                       </h4>
//                       <span
//                         style={{
//                           background: '#102dff',
//                           color: 'white',
//                           padding: '2px 8px',
//                           borderRadius: '12px',
//                           fontSize: '11px',
//                           fontWeight: '500',
//                         }}
//                       >
//                         {questions.length}/5
//                       </span>
//                     </div>

//                     <button
//                       onClick={addQuestion}
//                       disabled={questions.length >= 5}
//                       style={{
//                         padding: '8px 16px',
//                         background: questions.length >= 5 ? '#6c757d' : '#102dff',
//                         border: 'none',
//                         borderRadius: '20px',
//                         color: 'white',
//                         fontSize: '13px',
//                         fontWeight: '500',
//                         cursor: questions.length >= 5 ? 'not-allowed' : 'pointer',
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: '6px',
//                         opacity: questions.length >= 5 ? 0.7 : 1,
//                         transition: 'all 0.3s',
//                       }}
//                     >
//                       <AddIcon style={{ fontSize: '16px' }} />
//                       Add Question
//                     </button>
//                   </div>

//                   {/* Questions List */}
//                   <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
//                     {questions.map((q, index) => (
//                       <Paper
//                         key={q.id}
//                         elevation={0}
//                         style={{
//                           padding: '16px',
//                           background: mode === 'dark' ? '#363636' : '#ffffff',
//                           borderRadius: '8px',
//                           border: `1px solid ${mode === 'dark' ? '#444' : '#e0e0e0'}`,
//                           position: 'relative',
//                         }}
//                       >
//                         <div
//                           style={{
//                             position: 'absolute',
//                             top: '-10px',
//                             left: '12px',
//                             background: mode === 'dark' ? '#363636' : '#ffffff',
//                             padding: '0 8px',
//                             fontSize: '11px',
//                             fontWeight: '600',
//                             color: '#102dff',
//                             border: `1px solid ${mode === 'dark' ? '#444' : '#e0e0e0'}`,
//                             borderRadius: '12px',
//                           }}
//                         >
//                           Question #{index + 1}
//                         </div>

//                         <div style={{ display: 'grid', gap: '12px', marginTop: '8px' }}>
//                           {/* Question Field */}
//                           <div>
//                             <label
//                               style={{
//                                 display: 'block',
//                                 marginBottom: '4px',
//                                 color: mode === 'dark' ? '#ddd' : '#666',
//                                 fontSize: '12px',
//                                 fontWeight: '500',
//                               }}
//                             >
//                               Question
//                             </label>
//                             <input
//                               value={q.question}
//                               onChange={(e) => updateQuestionText(q.id, e.target.value)}
//                               style={{
//                                 width: '100%',
//                                 padding: '10px 12px',
//                                 borderRadius: '6px',
//                                 border: `1px solid ${mode === 'dark' ? '#555' : '#ddd'}`,
//                                 background: mode === 'dark' ? '#404040' : '#fff',
//                                 color: mode === 'dark' ? '#fff' : '#333',
//                                 fontSize: '13px',
//                               }}
//                               placeholder="Enter your question..."
//                             />
//                           </div>

//                           {/* Answer Field */}
//                           <div>
//                             <label
//                               style={{
//                                 display: 'block',
//                                 marginBottom: '4px',
//                                 color: mode === 'dark' ? '#ddd' : '#666',
//                                 fontSize: '12px',
//                                 fontWeight: '500',
//                               }}
//                             >
//                               Answer
//                             </label>
//                             <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
//                               <input
//                                 value={q.answer}
//                                 onChange={(e) => updateQuestionAnswer(q.id, e.target.value)}
//                                 style={{
//                                   flex: 1,
//                                   padding: '10px 12px',
//                                   borderRadius: '6px',
//                                   border: `1px solid ${mode === 'dark' ? '#555' : '#ddd'}`,
//                                   background: mode === 'dark' ? '#404040' : '#fff',
//                                   color: mode === 'dark' ? '#fff' : '#333',
//                                   fontSize: '13px',
//                                 }}
//                                 placeholder="Enter answer..."
//                               />
//                               {questions.length > 1 && (
//                                 <IconButton
//                                   onClick={() => removeQuestion(q.id)}
//                                   size="small"
//                                   style={{
//                                     color: '#dc3545',
//                                     background:
//                                       mode === 'dark'
//                                         ? 'rgba(220,53,69,0.1)'
//                                         : 'rgba(220,53,69,0.05)',
//                                     border: `1px solid ${mode === 'dark' ? '#dc3545' : '#dc3545'}`,
//                                     borderRadius: '6px',
//                                     padding: '6px',
//                                   }}
//                                 >
//                                   <RemoveIcon style={{ fontSize: '18px' }} />
//                                 </IconButton>
//                               )}
//                             </div>
//                           </div>
//                         </div>
//                       </Paper>
//                     ))}
//                   </div>

//                   {questions.length >= 5 && (
//                     <p
//                       style={{
//                         marginTop: '12px',
//                         fontSize: '12px',
//                         color: '#ff9800',
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: '4px',
//                       }}
//                     >
//                       ⚠️ Maximum 5 questions allowed
//                     </p>
//                   )}
//                 </div>
//               ) : null}

//               {/* Submit Button */}
//               <div
//                 style={{
//                   marginTop: '32px',
//                   paddingTop: '24px',
//                   borderTop: `1px solid ${mode === 'dark' ? '#333' : '#eee'}`,
//                   display: 'flex',
//                   justifyContent: 'flex-end',
//                   gap: '16px',
//                 }}
//               >
//                 <button
//                   onClick={resetForm}
//                   style={{
//                     padding: '12px 24px',
//                     background: 'transparent',
//                     border: `1px solid ${mode === 'dark' ? '#444' : '#ddd'}`,
//                     borderRadius: '8px',
//                     color: mode === 'dark' ? '#ddd' : '#666',
//                     fontSize: '14px',
//                     fontWeight: '500',
//                     cursor: 'pointer',
//                     transition: 'all 0.3s',
//                   }}
//                   onMouseOver={(e) => {
//                     e.target.style.background = mode === 'dark' ? '#333' : '#f8f9fa';
//                   }}
//                   onMouseOut={(e) => {
//                     e.target.style.background = 'transparent';
//                   }}
//                 >
//                   Clear Form
//                 </button>

//                 <button
//                   onClick={!submitLoading ? onSubmit : null}
//                   disabled={submitLoading || isPhoneDuplicate}
//                   style={{
//                     padding: '12px 32px',
//                     background: isPhoneDuplicate ? '#6c757d' : '#102dff',
//                     border: 'none',
//                     borderRadius: '8px',
//                     color: '#fff',
//                     fontSize: '14px',
//                     fontWeight: '600',
//                     cursor: submitLoading || isPhoneDuplicate ? 'not-allowed' : 'pointer',
//                     transition: 'all 0.3s',
//                     opacity: submitLoading || isPhoneDuplicate ? 0.7 : 1,
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '8px',
//                   }}
//                   onMouseOver={(e) => {
//                     if (!submitLoading && !isPhoneDuplicate) {
//                       e.target.style.background = '#0a24d4';
//                       e.target.style.transform = 'translateY(-1px)';
//                     }
//                   }}
//                   onMouseOut={(e) => {
//                     if (!submitLoading && !isPhoneDuplicate) {
//                       e.target.style.background = isPhoneDuplicate ? '#6c757d' : '#102dff';
//                       e.target.style.transform = 'translateY(0)';
//                     }
//                   }}
//                 >
//                   {submitLoading ? (
//                     <>
//                       <CircularProgress size={20} style={{ color: 'white' }} />
//                       Processing...
//                     </>
//                   ) : (
//                     <>
//                       <AddIcon style={{ fontSize: '18px' }} />
//                       {isPhoneDuplicate ? 'Duplicate Lead' : 'Add New Lead'}
//                     </>
//                   )}
//                 </button>
//               </div>
//             </div>
//           </Col>
//         </Row>
//       </Container>
//     </div>
//   );
// };












// 20-5-2026
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Getalldatasearch2, InsertuserData } from '../Redux/Actions/UsersAction';
import { Notify } from '../Utility/Notify';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { GetallProjectsdata } from '../Redux/Actions/Projects_Action';
import { Get_All_Sales_Action } from '../Redux/Actions/SalesAction';
import { GetAll_stage_Data } from '../Redux/Actions/Stage_Action';
import { GetAllchannalData } from '../Redux/Actions/ChannalActions';
import { GetCommunicationwayData } from '../Redux/Actions/CommunicationWay_Action';
import Switch from '@mui/material/Switch';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { GetAllCampainData } from '../Redux/Actions/Campaign_Actions';
import { useTheme } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import { useSidebarWidth } from '../Utility/useSidebarWidth';

/* ─────────────────────────────────────────────
   DESIGN TOKENS
───────────────────────────────────────────── */
const T = {
  navy:        '#0B1437',
  navyLight:   '#0F1D4A',
  navyBorder:  '#0D47A1',
  accent:      '#0D47A1',
  accentHover: '#0D47A1',
  accentBg:    'rgba(26,60,219,0.08)',
  white:       '#FFFFFF',
  offWhite:    '#f0f2f5',
  surface:     '#FFFFFF',
  border:      '#DDE3F0',
  borderLight: '#EEF1FA',
  text:        '#0B1437',
  textMuted:   '#6B7694',
  textLight:   '#9BA5C9',
  gold:        '#C8A96E',
  danger:      '#E24B4A',
  success:     '#1D9E75',
  warning:     '#BA7517',
  labelSize:   '11px',
  sectionFont: "'DM Sans', 'Georgia', sans-serif",
  bodyFont:    "'DM Sans', sans-serif",
  darkBg:      '#0f1117',
  darkSurface: '#1a1d2e',
  darkSurface2:'#161929',
  darkBorder:  '#2a2f45',
  darkText:    '#e5e7eb',
  darkMuted:   '#6b7280',
};

/* ── Google Fonts ── */
if (typeof document !== 'undefined' && !document.getElementById('azure-fonts')) {
  const link = document.createElement('link');
  link.id = 'azure-fonts';
  link.rel = 'stylesheet';
  link.href = 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;600;700&family=DM+Sans:wght@300;400;500;600&display=swap';
  document.head.appendChild(link);
}

/* ─────────────────────────
   Mini Components
───────────────────────── */
const SectionTag = ({ number, label }) => (
  <div style={{ display:'flex', alignItems:'center', gap:'10px', marginBottom:'20px' }}>
    <div style={{ width:'28px', height:'2px', background: T.accent }} />
    <span style={{
      fontFamily: T.bodyFont, fontSize: T.labelSize, fontWeight:'700',
      letterSpacing:'2px', color: T.accent, textTransform:'uppercase',
    }}>
      Section {String(number).padStart(2,'0')} / {label}
    </span>
  </div>
);

const FieldLabel = ({ children, isDark }) => (
  <label style={{
    display:'block', marginBottom:'6px', fontFamily: T.bodyFont,
    fontSize: T.labelSize, fontWeight:'700', letterSpacing:'1.5px',
    textTransform:'uppercase', color: isDark ? T.darkMuted : T.textMuted,
  }}>
    {children}
  </label>
);

const getInputStyle = (isDark) => ({
  width:'100%', padding:'10px 14px', borderRadius:'10px',
  border:`1.5px solid ${isDark ? T.darkBorder : T.border}`,
  background: isDark ? T.darkSurface2 : '#FAFBFF',
  color: isDark ? T.darkText : T.text,
  fontSize:'13px', fontFamily: T.bodyFont,
  outline:'none', transition:'border-color .2s, box-shadow .2s', boxSizing:'border-box',
  letterSpacing:'0.01em',
});

const SectionCard = ({ children, isDark, style }) => (
  <div style={{
    background: isDark ? T.darkSurface : T.surface,
    border:`1px solid ${isDark ? T.darkBorder : T.border}`,
    borderRadius:'12px', padding:'28px', marginBottom:'20px', ...style,
  }}>
    {children}
  </div>
);

/* ─────────────────────────────────────────────
   LuxuryAutocomplete
───────────────────────────────────────────── */
const getProjectIcon = (name = '') => {
  const n = name.toLowerCase();
  if (n.includes('villa') || n.includes('residence')) return '🏡';
  if (n.includes('beach') || n.includes('leisure') || n.includes('oasis')) return '🏖';
  if (n.includes('commercial') || n.includes('hub') || n.includes('general')) return '🏗';
  if (n.includes('logistic') || n.includes('industrial')) return '🏭';
  if (n.includes('urban') || n.includes('city')) return '🏙';
  if (n.includes('luxury') || n.includes('premium')) return '💎';
  return '🏢';
};

const getProjectSubtitle = (name = '') => {
  const n = name.toLowerCase();
  if (n.includes('villa')) return 'LUXURY LIVING';
  if (n.includes('beach') || n.includes('oasis')) return 'LEISURE ESTATES';
  if (n.includes('commercial') || n.includes('hub')) return 'COMMERCIAL HUB';
  if (n.includes('logistic')) return 'INDUSTRIAL';
  if (n.includes('urban')) return 'URBAN PORTFOLIO';
  if (n.includes('residence') || n.includes('tower')) return 'RESIDENTIAL';
  return 'REAL ESTATE';
};

const LuxuryAutocomplete = ({
  options = [],
  value,
  onChange,
  placeholder,
  loading,
  isDark,
  getLabel,
  getSubtitle,
  getIcon,
  disabled,
}) => {
  const [open, setOpen]     = useState(false);
  const [search, setSearch] = useState('');
  const ref                 = React.useRef(null);

  const labelFn    = getLabel    || (o => o?.name || '');
  const subtitleFn = getSubtitle || (o => getProjectSubtitle(o?.name || ''));
  const iconFn     = getIcon     || (o => getProjectIcon(o?.name || ''));

  const filtered = options.filter(o =>
    labelFn(o).toLowerCase().includes(search.toLowerCase())
  );

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div ref={ref} style={{ position: 'relative', width: '100%' }}>

      {/* ── Trigger ── */}
      <div
        onClick={() => !disabled && setOpen(o => !o)}
        style={{
          display: 'flex', alignItems: 'center', gap: '10px',
          padding: '0 14px', height: '42px',
          borderRadius: '10px',
          border: `1.5px solid ${open ? T.accent : isDark ? T.darkBorder : T.border}`,
          background: isDark ? T.darkSurface2 : '#FAFBFF',
          cursor: disabled ? 'not-allowed' : 'pointer',
          transition: 'border-color .2s, box-shadow .2s',
          boxShadow: open ? `0 0 0 3px rgba(13,71,161,0.08)` : 'none',
          opacity: disabled ? 0.6 : 1,
          userSelect: 'none',
        }}
      >
        {value ? (
          <>
            <div style={{
              width: '28px', height: '28px', borderRadius: '7px', flexShrink: 0,
              background: isDark ? T.darkBorder : '#EEF1FA',
              display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px',
            }}>
              {iconFn(value)}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{
                fontSize: '13px', fontWeight: '600',
                color: isDark ? T.darkText : T.text,
                fontFamily: T.bodyFont,
                whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
              }}>
                {labelFn(value)}
              </div>
              <div style={{
                fontSize: '10px', letterSpacing: '1.5px', color: T.accent,
                fontWeight: '700', fontFamily: T.bodyFont, textTransform: 'uppercase',
              }}>
                {subtitleFn(value)}
              </div>
            </div>
          </>
        ) : (
          <span style={{ fontSize: '13px', color: isDark ? T.darkMuted : T.textLight, fontFamily: T.bodyFont }}>
            {placeholder || 'Select...'}
          </span>
        )}
        {/* Chevron */}
        <svg
          width="12" height="12" viewBox="0 0 12 12" fill="none"
          style={{ flexShrink: 0, marginLeft: 'auto', transition: 'transform .2s', transform: open ? 'rotate(180deg)' : 'none' }}
        >
          <path d="M2 4l4 4 4-4" stroke={isDark ? T.darkMuted : T.textMuted} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>

      {/* ── Dropdown ── */}
      {open && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 6px)', left: 0, right: 0, zIndex: 9999,
          background: isDark ? T.darkSurface : '#FFFFFF',
          border: `1.5px solid ${isDark ? T.darkBorder : '#DDE3F0'}`,
          borderRadius: '12px',
          boxShadow: '0 12px 40px rgba(11,20,55,0.15)',
          overflow: 'hidden',
          maxHeight: '320px',
          display: 'flex', flexDirection: 'column',
        }}>

          {/* Search bar */}
          <div style={{ padding: '10px 12px', borderBottom: `1px solid ${isDark ? T.darkBorder : '#EEF1FA'}` }}>
            <div style={{
              display: 'flex', alignItems: 'center', gap: '8px',
              padding: '8px 12px', borderRadius: '8px',
              background: isDark ? T.darkSurface2 : '#F4F6FB',
            }}>
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <circle cx="6" cy="6" r="4.5" stroke={isDark ? T.darkMuted : T.textMuted} strokeWidth="1.3"/>
                <path d="M9.5 9.5l2 2" stroke={isDark ? T.darkMuted : T.textMuted} strokeWidth="1.3" strokeLinecap="round"/>
              </svg>
              <input
                autoFocus
                value={search}
                onChange={e => setSearch(e.target.value)}
                placeholder={`Search ${placeholder || 'options'}...`}
                style={{
                  border: 'none', outline: 'none', background: 'transparent',
                  fontSize: '13px', fontFamily: T.bodyFont, flex: 1,
                  color: isDark ? T.darkText : T.text,
                }}
              />
              {search && (
                <span
                  onClick={() => setSearch('')}
                  style={{ cursor: 'pointer', color: isDark ? T.darkMuted : T.textLight, fontSize: '16px', lineHeight: 1 }}
                >×</span>
              )}
            </div>
          </div>

          {/* Options list */}
          <div style={{ overflowY: 'auto', flex: 1 }}>
            {loading ? (
              <div style={{ padding: '20px', textAlign: 'center', fontSize: '13px', color: isDark ? T.darkMuted : T.textMuted, fontFamily: T.bodyFont }}>
                Loading...
              </div>
            ) : filtered.length === 0 ? (
              <div style={{ padding: '20px', textAlign: 'center', fontSize: '13px', color: isDark ? T.darkMuted : T.textMuted, fontFamily: T.bodyFont }}>
                No results found
              </div>
            ) : filtered.map((opt, i) => {
              const isSelected = value && labelFn(value) === labelFn(opt);
              return (
                <div
                  key={opt._id || i}
                  onClick={() => { onChange(opt); setOpen(false); setSearch(''); }}
                  style={{
                    display: 'flex', alignItems: 'center', gap: '12px',
                    padding: '11px 14px', cursor: 'pointer',
                    background: isSelected
                      ? isDark ? 'rgba(13,71,161,0.15)' : '#F0F4FF'
                      : 'transparent',
                    borderLeft: isSelected ? `3px solid ${T.accent}` : '3px solid transparent',
                    transition: 'background .12s',
                  }}
                  onMouseEnter={e => { if (!isSelected) e.currentTarget.style.background = isDark ? 'rgba(255,255,255,0.04)' : '#F8F9FD'; }}
                  onMouseLeave={e => { if (!isSelected) e.currentTarget.style.background = isSelected ? (isDark ? 'rgba(13,71,161,0.15)' : '#F0F4FF') : 'transparent'; }}
                >
                  {/* Icon box */}
                  <div style={{
                    width: '32px', height: '32px', borderRadius: '8px', flexShrink: 0,
                    background: isSelected
                      ? isDark ? 'rgba(13,71,161,0.25)' : '#DDEAFF'
                      : isDark ? T.darkBorder : '#EEF1FA',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '15px',
                  }}>
                    {iconFn(opt)}
                  </div>

                  {/* Text */}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{
                      fontSize: '13px', fontWeight: isSelected ? '600' : '500',
                      color: isSelected ? T.accent : isDark ? T.darkText : T.text,
                      fontFamily: T.bodyFont,
                      whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                    }}>
                      {labelFn(opt)}
                    </div>
                    <div style={{
                      fontSize: '10px', letterSpacing: '1.2px', fontWeight: '700',
                      color: isSelected ? T.accent : isDark ? T.darkMuted : T.textLight,
                      fontFamily: T.bodyFont, textTransform: 'uppercase', marginTop: '1px',
                    }}>
                      {subtitleFn(opt)}
                    </div>
                  </div>

                  {/* Check icon */}
                  {isSelected && (
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ flexShrink: 0 }}>
                      <circle cx="8" cy="8" r="7" stroke={T.accent} strokeWidth="1.5"/>
                      <path d="M5 8l2 2 4-4" stroke={T.accent} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  )}
                </div>
              );
            })}
          </div>

          {/* Footer */}
          <div style={{
            padding: '10px 14px', textAlign: 'center',
            borderTop: `1px solid ${isDark ? T.darkBorder : '#EEF1FA'}`,
          }}>
            <span style={{
              fontSize: '11px', letterSpacing: '1.5px', fontWeight: '700',
              color: T.accent, textTransform: 'uppercase', fontFamily: T.bodyFont, cursor: 'pointer',
            }}>
              VIEW ALL ENTITIES
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

/* ─────────────────────────────────────────────
   MAIN COMPONENT
───────────────────────────────────────────── */
export const AddClients = () => {
  const theme        = useTheme();
  const isDark       = theme.palette.mode === 'dark';
  const dispatch     = useDispatch();
  const sidebarWidth = useSidebarWidth();

  /* ── Questions ── */
  const [questions,      setQuestions]      = useState([{ id:1, question:'', answer:'' }]);
  const [nextQuestionId, setNextQuestionId] = useState(2);

  const addQuestion    = () => { setQuestions(p => [...p, { id:nextQuestionId, question:'', answer:'' }]); setNextQuestionId(n => n+1); };
  const removeQuestion = (id) => { if (questions.length > 1) setQuestions(p => p.filter(q => q.id!==id)); else Notify('info','You need at least one question','Info'); };
  const updateQuestionText   = (id, v) => setQuestions(p => p.map(q => q.id===id ? {...q, question:v} : q));
  const updateQuestionAnswer = (id, v) => setQuestions(p => p.map(q => q.id===id ? {...q, answer:v}   : q));

  /* ── User ── */
  const [userlogin, setuserlogin] = useState(null);
  useEffect(() => {
    try { const u = localStorage.getItem('user'); if (u) setuserlogin(JSON.parse(u)); } catch { setuserlogin(null); }
  }, []);

  const [submitLoading, setSubmitLoading] = useState(false);

  /* ── Phone ── */
  const [value,               setValue]              = useState('');
  const [phonenumber2,        setphonenumber2]        = useState('');
  const [whatsappnumber,      setwhatsappnumber]      = useState('');
  const [cleanPhoneForSearch, setCleanPhoneForSearch] = useState('');
  const [error,               setError]              = useState('');
  const [Errorphonenumber2,   setErrorphonenumber2]  = useState('');
  const [whatsappnumbererror, setwhatsappnumbererror] = useState('');
  const [isPhoneDuplicate,    setIsPhoneDuplicate]   = useState(false);
  const [duplicateLeadInfo,   setDuplicateLeadInfo]  = useState(null);
  const [countryName,         setCountryName]        = useState('');

  const allUsers = useSelector(s => s.Allusers?.Get_users?.data || []);
  const cleanPhoneNumber = (phone) => phone ? phone.replace(/[^\d]/g,'') : '';
  const resetPhoneFields = () => { setValue(''); setphonenumber2(''); setwhatsappnumber(''); };

  const handlePhoneChange = (newValue, countryData) => {
    setValue(newValue); setIsPhoneDuplicate(false); setDuplicateLeadInfo(null); setError('');
    if (countryData) setCountryName(countryData.name);
    setCleanPhoneForSearch(cleanPhoneNumber(newValue));
  };

  const checkPhoneDuplicate = async (clean) => {
    if (!clean || clean.length < 5) { setIsPhoneDuplicate(false); setDuplicateLeadInfo(null); return; }
    try {
      const dup = allUsers.find(u => u.phone && cleanPhoneNumber(u.phone) === clean);
      if (dup) {
        setIsPhoneDuplicate(true);
        setDuplicateLeadInfo({ leadName:dup.name, salesName:dup.sales?.name||'No Sales', leadId:dup._id, dateAdded:dup.date?new Date(dup.date).toLocaleDateString():'Unknown' });
        return;
      }
      const res = await dispatch(Getalldatasearch2(`phone=${clean}`));
      if (res?.payload?.data?.length > 0) {
        const d = res.payload.data[0];
        setIsPhoneDuplicate(true);
        setDuplicateLeadInfo({ leadName:d.name||d.leadname, salesName:d.sales?.name||d.salesname?.name||d.salesname||'No Sales Assigned', leadId:d._id, dateAdded:d.date?new Date(d.date).toLocaleDateString():'Unknown' });
      } else { setIsPhoneDuplicate(false); setDuplicateLeadInfo(null); }
    } catch { setIsPhoneDuplicate(false); setDuplicateLeadInfo(null); }
  };

  const validatePhoneBeforeSubmit = async () => {
    if (!value) return false;
    const clean = cleanPhoneNumber(value);
    try {
      const dup = allUsers.find(u => u.phone && cleanPhoneNumber(u.phone) === clean);
      if (dup) { setDuplicateLeadInfo({ leadName:dup.name, salesName:dup.sales?.name||'No Sales', leadId:dup._id, dateAdded:dup.date?new Date(dup.date).toLocaleDateString():'Unknown' }); return true; }
      const res = await dispatch(Getalldatasearch2(`phone=${clean}`));
      if (res?.payload?.data?.length > 0) {
        const d = res.payload.data[0];
        setDuplicateLeadInfo({ leadName:d.name||d.leadname, salesName:d.sales?.name||d.salesname?.name||d.salesname||'No Sales Assigned', leadId:d._id, dateAdded:d.date?new Date(d.date).toLocaleDateString():'Unknown' });
        return true;
      }
      return false;
    } catch { return false; }
  };

  const handlePhoneBlur = async () => {
    if (!value) { setError('required'); return; }
    const pn = parsePhoneNumberFromString(value);
    if (!pn || !pn.isValid()) { setError(''); return; }
    setError('');
    const clean = cleanPhoneNumber(value);
    if (clean && clean.length >= 5) await checkPhoneDuplicate(clean);
  };

  const handlePhone2Change         = (v) => { setphonenumber2(v);   setErrorphonenumber2('');   };
  const handlewhatsappnumberChange = (v) => { setwhatsappnumber(v); setwhatsappnumbererror(''); };
  const handleBlurphonenumber2     = () => { if (phonenumber2)    { const p = parsePhoneNumberFromString(phonenumber2);    setErrorphonenumber2(p&&p.isValid()?'':'-');    } };
  const handleBlurwhatsappnumber   = () => { if (whatsappnumber)  { const p = parsePhoneNumberFromString(whatsappnumber);  setwhatsappnumbererror(p&&p.isValid()?'':'-'); } };

  /* ── Date ── */
  const [dateonly, setDateonly] = useState('');
  useEffect(() => {
    const d = new Date();
    setDateonly(`${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`);
  }, []);

  /* ── Fields ── */
  const [name,             setName]             = useState('');
  const [email,            setEmail]            = useState('');
  const [note,             setNote]             = useState('');
  const [project,          setproject]          = useState('');
  const [salesdata,        setsalesdata]        = useState('');
  const [loading,          setloading]          = useState(false);
  const [stage,            setstage]            = useState('');
  const [Channal,          setchannal]          = useState('');
  const [Communicationway, setcommunicationwat] = useState('');
  const [budget,           setbudget]           = useState(0);
  const [checked,          setChecked]          = useState(true);
  const [Leedtype,         setLeedtype]         = useState('Fresh');
  const [campaignid,       setcampaignid]       = useState('');
  const [jobDescription,   setJobDescription]   = useState('');
  const [isLoading,        setIsLoading]        = useState(false);
  const [dataLoaded,       setDataLoaded]       = useState(false);
  const [campaignRedirectLink, setCampaignRedirectLink] = useState('');

  useEffect(() => { setLeedtype(checked ? 'Fresh' : 'Cold'); }, [checked]);

  /* ── Load data ── */
  const loadFormData = async () => {
    if (!dataLoaded) {
      setIsLoading(true);
      try {
        await Promise.all([
          dispatch(GetAll_stage_Data()), dispatch(GetAllchannalData()),
          dispatch(GetCommunicationwayData()), dispatch(GetAllCampainData()),
          dispatch(GetallProjectsdata()), dispatch(Get_All_Sales_Action()),
        ]);
        setDataLoaded(true);
      } catch(e) { console.error(e); } finally { setIsLoading(false); }
    }
  };
  useEffect(() => { loadFormData(); }, [dispatch]);

  const resgetallchannal          = useSelector(s => s.AllChannalRoot.channal);
  const resgetallcommunicationway = useSelector(s => s.AllCommunicationway.communicationway);
  const resgetcampaindata         = useSelector(s => s.AllCampaign.campaign);
  const ressales                  = useSelector(s => s.AllSales.sales);
  const resProjects               = useSelector(s => s.AllProjects.Projects);
  const res                       = useSelector(s => s.Allusers.Get_users);

  const res_getallchannal_array          = Array.isArray(resgetallchannal?.data)          ? resgetallchannal.data          : [];
  const res_getallcommunicationway_array = Array.isArray(resgetallcommunicationway?.data) ? resgetallcommunicationway.data : [];
  const res_get_campaign_data_array      = Array.isArray(resgetcampaindata?.data)         ? resgetcampaindata.data         : [];
  const Allprojects = resProjects?.data || [];

  let salesData = ressales?.data
    ? ressales.data
        .filter(s => !['Default','Default M','Default T','Default S','Developer','Deveolper','Dev'].includes(s.name))
        .sort((a,b) => a.name==='No Sales'?-1:b.name==='No Sales'?1:0)
    : [];

  const getCurrentUser = () => {
    try {
      const u = localStorage.getItem('user'); if (!u) return null;
      const p = JSON.parse(u);
      if (p?.data?._id) return p; if (p?._id) return { data: p }; return null;
    } catch { return null; }
  };

  const getSalesOptions = () => {
    if (!userlogin?.data?.role) return salesData;
    if (userlogin.data.role==='Sales') {
      const me = salesData.find(s => s?.userlog?.email===userlogin?.data?.email);
      if (me) { if (!salesdata) setsalesdata(me._id); return [me]; } return [];
    }
    if (userlogin.data.role==='Team Leader') return salesData.filter(s => s?.teamleader?._id===userlogin?.data?._id);
    return salesData;
  };
  const salesOptions = getSalesOptions();

  const getHomeRoute = () => {
    switch(userlogin?.data?.role) {
      case 'Admin':       return '/AllLeadsForAdmin';
      case 'Sales':       return '/AllLeadsForSales';
      case 'Team Leader': return '/AllLeadsForTeamLeader';
      case 'Manager':     return '/LeadsForManagers';
      case 'Marketer':    return '/ALLLeadsForMarketer';
      default:            return '/';
    }
  };

  const isAdminOrMarketer = userlogin?.data?.role==='Admin' || userlogin?.data?.role==='Marketer';

  /* ── Submit ── */
  const onSubmit = async (e) => {
    e.preventDefault();
    const currentUser = getCurrentUser();
    if (!currentUser?.data?._id) { Notify('error','User session expired. Please login again.','Error Message'); return; }
    if (!name)       { Notify('error','Name is Required','Error Message'); return; }
    if (!value)      { Notify('error','Phone is Required','Error Message'); return; }
    if (!Channal)    { Notify('error','Channel is Required','error'); return; }
    if (!Leedtype)   { Notify('error','Leed Type is Required','error'); return; }
    if (!campaignid) { Notify('error','Campaign is Required','error'); return; }

    const isDuplicate = await validatePhoneBeforeSubmit();
    if (isDuplicate) {
      setIsPhoneDuplicate(true);
      let msg = `This phone number is already registered!\nLead: ${duplicateLeadInfo?.leadName||'Unknown'}\n`;
      if (isAdminOrMarketer) msg += `Assigned to: ${duplicateLeadInfo?.salesName||'No Sales'}\n`;
      msg += `Date Added: ${duplicateLeadInfo?.dateAdded||'Unknown'}`;
      Notify('warning', msg, 'Duplicate Lead Detected');
      return;
    }

    setSubmitLoading(true);
    try {
      const leadData = {
        name, email, phone:'+'+value, project, sales:salesdata, notes:note,
        date:Date.now(), stage, chanel:Channal, communicationway:Communicationway,
        leedtype:Leedtype, budget:budget||0, dayonly:dateonly,
        last_stage_date_updated:dateonly, lastdateassign:new Date().toLocaleString(),
        lastcommentdate:'-', addby:currentUser.data._id, updatedby:currentUser.data._id,
        campaign:campaignid, campaignRedirectLink:campaignRedirectLink||'',
        unit_price:0, whatsappnumber:cleanPhoneNumber(whatsappnumber),
        phonenumber2:cleanPhoneNumber(phonenumber2), jobdescription:jobDescription,
        assign:isAdminOrMarketer,
        question1_text:questions[0]?.question||'', question1_answer:questions[0]?.answer||'',
        question2_text:questions[1]?.question||'', question2_answer:questions[1]?.answer||'',
        question3_text:questions[2]?.question||'', question3_answer:questions[2]?.answer||'',
        question4_text:questions[3]?.question||'', question4_answer:questions[3]?.answer||'',
        question5_text:questions[4]?.question||'', question5_answer:questions[4]?.answer||'',
      };
      const actionResult = await dispatch(InsertuserData(leadData));
      if (actionResult?.error) throw actionResult.error;
      setSubmitLoading(false);
    } catch (err) {
      if (err?.response?.status === 400) {
        const d = err.response.data;
        setIsPhoneDuplicate(true);
        setDuplicateLeadInfo({ leadName:d.leadname||name||'Unknown', salesName:d.salesname||'Not assigned', leadId:d.leadId, dateAdded:d.existingLead?.date?new Date(d.existingLead.date).toLocaleDateString():'Unknown' });
        let msg = `${d.message||'Phone number already exists'}\nLead: ${d.leadname||name||'Unknown'}\n`;
        if (isAdminOrMarketer) msg += `Assigned to: ${d.salesname||'Not assigned'}\n`;
        if (d.leadId) msg += `Lead ID: ${d.leadId}`;
        Notify('error', msg, 'Duplicate Lead');
      } else {
        Notify('error', err?.response?.data?.message||err?.message||'Failed to add lead','Error Message');
      }
      setSubmitLoading(false);
    }
  };

  useEffect(() => {
    if (loading===false && res) {
      const lead = res?.data?.data?.lead || (res.data?._id ? res.data : null) || res.payload?.data?.lead;
      if (lead) {
        Notify('success',`✅ Lead added successfully!\nName: ${lead.name||res.data?.name}`,'Success Message');
        resetForm();
        setTimeout(() => window.location.reload(), 2000);
      }
      setloading(false);
    }
  }, [loading, res]);

  const resetForm = () => {
    setName(''); setEmail(''); setNote(''); setproject(''); setsalesdata(''); setchannal('');
    setstage(''); setcommunicationwat(''); setcampaignid(''); setCampaignRedirectLink('');
    setJobDescription(''); setbudget(0); setChecked(true); setLeedtype('Fresh');
    setIsPhoneDuplicate(false); setDuplicateLeadInfo(null); setError('');
    setErrorphonenumber2(''); setwhatsappnumbererror(''); setCleanPhoneForSearch('');
    setQuestions([{ id:1, question:'', answer:'' }]); setNextQuestionId(2);
    resetPhoneFields(); setDataLoaded(false); loadFormData();
    window.location.reload(false);
  };

  const refreshFormData = () => { setDataLoaded(false); loadFormData(); window.location.reload(false); };

  /* ── Shared styles ── */
  const inputStyle = getInputStyle(isDark);

  const phoneButtonStyle = {
    background: isDark ? T.darkSurface2 : '#F4F6FB',
    border: `1.5px solid ${isDark ? T.darkBorder : T.border}`,
    borderRadius: '10px 0 0 10px',
    borderRight: 'none',
    padding: '0 10px',
  };

  const phoneDropdownStyle = {
    background: isDark ? T.darkSurface : '#FFFFFF',
    color: isDark ? T.darkText : T.text,
    borderRadius: '10px',
    border: `1.5px solid ${isDark ? T.darkBorder : T.border}`,
    boxShadow: '0 8px 32px rgba(11,20,55,0.12)',
    marginTop: '4px',
  };

  const phoneInputStyle = {
    ...inputStyle,
    height: '42px',
    paddingLeft: '52px',
    borderRadius: '0 10px 10px 0',
    width: '100%',
  };

  /* ── Channel icon helper ── */
  const getChannelIcon = (o) => {
    const n = (o?.name || '').toLowerCase();
    if (n.includes('social') || n.includes('instagram') || n.includes('facebook')) return '📱';
    if (n.includes('email')) return '📧';
    if (n.includes('referral')) return '🤝';
    if (n.includes('web') || n.includes('site')) return '🌐';
    if (n.includes('call') || n.includes('phone')) return '📞';
    if (n.includes('whatsapp')) return '💬';
    return '📡';
  };

  const getChannelSubtitle = (o) => {
    const n = (o?.name || '').toLowerCase();
    if (n.includes('social')) return 'DIGITAL MEDIA';
    if (n.includes('referral')) return 'WORD OF MOUTH';
    if (n.includes('web')) return 'ONLINE';
    if (n.includes('email')) return 'EMAIL MARKETING';
    return 'ACQUISITION CHANNEL';
  };

  /* ─────────────────────────
     RENDER
  ───────────────────────── */
  return (
    <div style={{
      position:'fixed', top:'50px', left:sidebarWidth, right:0, bottom:0,
      transition:'left 0.25s cubic-bezier(0.4,0,0.2,1)',
      display:'flex', flexDirection:'column', overflow:'hidden',
      backgroundColor: isDark ? T.darkBg : T.offWhite,
      fontFamily: T.bodyFont,
    }}>

      {/* ── Breadcrumb ── */}
      <div style={{
        padding:'14px 28px', flexShrink:0,
        backgroundColor: isDark ? T.darkSurface : T.offWhite,
        display:'flex', alignItems:'center', gap:'8px', fontSize:'13px',
      }}>
        <Link to={getHomeRoute()} style={{ textDecoration:'none', color: isDark ? '#9ca3af' : '#6b7280', fontWeight:'500' }}>
          Home
        </Link>
        <span style={{ color: isDark ? '#4b5563' : '#d1d5db' }}>/</span>
        <span style={{ color: isDark ? '#e5e7eb' : '#111827', fontWeight:'600' }}>Add New Lead</span>
      </div>

      {/* ── Scrollable Body ── */}
      <div style={{ flex:1, overflowY:'auto', overflowX:'hidden', display:'flex', flexDirection:'column' }}>
        <div style={{ padding:'24px 28px', flex:1 }}>

          {/* Page Heading */}
          <div style={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', marginBottom:'28px' }}>
            <div>
              <div style={{ fontSize:T.labelSize, fontWeight:'700', letterSpacing:'2px', textTransform:'uppercase', color:T.accent, marginBottom:'6px', fontFamily:T.bodyFont }}>
                LEADS / REGISTRATION
              </div>
              <h1 style={{ fontFamily:T.sectionFont, fontSize:'34px', fontWeight:'700', color:isDark?T.darkText:T.text, margin:'0 0 6px', letterSpacing:'-0.5px' }}>
                Add New Lead
              </h1>
              <p style={{ margin:0, fontSize:'14px', color:isDark?T.darkMuted:T.textMuted, fontWeight:'300' }}>
                Initialize a high-intent profile within the system.
              </p>
            </div>
            <button
              onClick={refreshFormData} disabled={isLoading}
              style={{
                padding:'9px 20px', background:isDark?T.darkSurface:T.navy,
                border:`1px solid ${isDark?T.darkBorder:T.navyBorder}`,
                borderRadius:'10px', color:'#fff', fontSize:'13px', fontWeight:'500',
                cursor:'pointer', display:'flex', alignItems:'center', gap:'8px', fontFamily:T.bodyFont,
              }}
            >
              {isLoading ? <><CircularProgress size={14} style={{ color:'white' }} /> Loading...</> : 'Refresh Data'}
            </button>
          </div>

          {/* ══ SECTION 01 / IDENTITY ══ */}
          <SectionCard isDark={isDark}>
            <SectionTag number={1} label="Identity" />
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'20px' }}>

              <div>
                <FieldLabel isDark={isDark}>Full Name *</FieldLabel>
                <input value={name} onChange={e=>setName(e.target.value)} style={inputStyle}
                  type="text" placeholder="e.g. Alexander Hamilton"
                  onFocus={e=>{ e.target.style.borderColor=T.accent; e.target.style.boxShadow=`0 0 0 3px rgba(13,71,161,0.08)`; }}
                  onBlur={e=>{ e.target.style.borderColor=isDark?T.darkBorder:T.border; e.target.style.boxShadow='none'; }}
                />
              </div>

              <div>
                <FieldLabel isDark={isDark}>Email Address (Optional)</FieldLabel>
                <input value={email} onChange={e=>setEmail(e.target.value)} style={inputStyle}
                  type="email" placeholder="client@private-estate.com"
                  onFocus={e=>{ e.target.style.borderColor=T.accent; e.target.style.boxShadow=`0 0 0 3px rgba(13,71,161,0.08)`; }}
                  onBlur={e=>{ e.target.style.borderColor=isDark?T.darkBorder:T.border; e.target.style.boxShadow='none'; }}
                />
              </div>

              {/* Primary Phone */}
              <div>
                <FieldLabel isDark={isDark}>Primary Phone *</FieldLabel>
                <PhoneInput
                  country={'ae'} value={value}
                  onChange={handlePhoneChange} onBlur={handlePhoneBlur}
                  preferredCountries={['ae','us','gb']}
                  inputStyle={{
                    ...phoneInputStyle,
                    border: isPhoneDuplicate
                      ? `1.5px solid ${T.danger}`
                      : `1.5px solid ${isDark?T.darkBorder:T.border}`,
                  }}
                  buttonStyle={phoneButtonStyle}
                  dropdownStyle={phoneDropdownStyle}
                  containerStyle={{ width:'100%' }}
                />
                {isPhoneDuplicate && duplicateLeadInfo && (
                  <div style={{ marginTop:'8px', padding:'12px 14px', background:isDark?'rgba(226,75,74,0.1)':'#FFF8F0', border:`1.5px solid ${isDark?'rgba(226,75,74,0.3)':'#F5C4B3'}`, borderRadius:'10px', fontSize:'12px', color:T.danger, fontFamily:T.bodyFont }}>
                    <div style={{ fontWeight:'700', marginBottom:'4px' }}>⚠ Duplicate Lead Detected</div>
                    <div>Lead: <strong>{duplicateLeadInfo.leadName}</strong></div>
                    {isAdminOrMarketer && <div>Assigned to: <strong>{duplicateLeadInfo.salesName}</strong></div>}
                    <div style={{ color:isDark?T.darkMuted:T.textMuted, marginTop:'2px' }}>Added: {duplicateLeadInfo.dateAdded}</div>
                  </div>
                )}
              </div>

              {/* Second Phone */}
              <div>
                <FieldLabel isDark={isDark}>Second Phone (Optional)</FieldLabel>
                <PhoneInput
                  country={'ae'} value={phonenumber2}
                  onChange={handlePhone2Change} onBlur={handleBlurphonenumber2}
                  preferredCountries={['ae','us','gb']}
                  inputStyle={phoneInputStyle}
                  buttonStyle={phoneButtonStyle}
                  dropdownStyle={phoneDropdownStyle}
                  containerStyle={{ width:'100%' }}
                />
              </div>

              {/* WhatsApp */}
              <div>
                <FieldLabel isDark={isDark}>WhatsApp Number (Optional)</FieldLabel>
                <PhoneInput
                  country={'ae'} value={whatsappnumber}
                  onChange={handlewhatsappnumberChange} onBlur={handleBlurwhatsappnumber}
                  preferredCountries={['ae','us','gb']}
                  inputStyle={phoneInputStyle}
                  buttonStyle={phoneButtonStyle}
                  dropdownStyle={phoneDropdownStyle}
                  containerStyle={{ width:'100%' }}
                />
              </div>

            </div>
          </SectionCard>

          {/* ══ SECTION 02 + 03 ══ */}
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'20px', marginBottom:'20px' }}>

            {/* ── SECTION 02 / ACQUISITION ── */}
            <div style={{ background:isDark?T.darkSurface:T.surface, border:`1px solid ${isDark?T.darkBorder:T.border}`, borderRadius:'12px', padding:'28px' }}>
              <SectionTag number={2} label="Acquisition" />
              <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>

                {/* Project */}
                <div>
                  <FieldLabel isDark={isDark}>Project *</FieldLabel>
                  <LuxuryAutocomplete
                    options={Allprojects}
                    value={Allprojects.find(p => p._id === project) || null}
                    onChange={v => setproject(v ? v._id : '')}
                    placeholder="Select project"
                    loading={isLoading}
                    isDark={isDark}
                  />
                </div>

                {/* Sales */}
                <div>
                  <FieldLabel isDark={isDark}>Sales *</FieldLabel>
                  <LuxuryAutocomplete
                    options={salesOptions}
                    value={salesData.find(s => s._id === salesdata) || null}
                    onChange={v => setsalesdata(v ? v._id : '')}
                    placeholder="Select sales"
                    loading={isLoading}
                    isDark={isDark}
                    disabled={userlogin?.data?.role === 'Sales'}
                    getIcon={() => '👤'}
                    getSubtitle={o => o?.teamleader?.name ? `TEAM: ${o.teamleader.name.toUpperCase()}` : 'SALES AGENT'}
                  />
                </div>

                {/* Campaign + Channel */}
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'12px' }}>
                  <div>
                    <FieldLabel isDark={isDark}>Campaign *</FieldLabel>
                    <LuxuryAutocomplete
                      options={res_get_campaign_data_array}
                      value={res_get_campaign_data_array.find(i => i._id === campaignid) || null}
                      onChange={v => setcampaignid(v ? v._id : '')}
                      placeholder="Select campaign"
                      loading={isLoading}
                      isDark={isDark}
                      getLabel={o => o?.CampainName || ''}
                      getIcon={() => '📣'}
                      getSubtitle={() => 'CAMPAIGN'}
                    />
                  </div>
                  <div>
                    <FieldLabel isDark={isDark}>Channel *</FieldLabel>
                    <LuxuryAutocomplete
                      options={res_getallchannal_array}
                      value={res_getallchannal_array.find(i => i._id === Channal) || null}
                      onChange={v => setchannal(v ? v._id : '')}
                      placeholder="Select channel"
                      loading={isLoading}
                      isDark={isDark}
                      getIcon={getChannelIcon}
                      getSubtitle={getChannelSubtitle}
                    />
                  </div>
                </div>

                {/* Communication Way — chips */}
                <div>
                  <FieldLabel isDark={isDark}>Communication Way (Optional)</FieldLabel>
                  <div style={{ display:'flex', flexWrap:'wrap', gap:'8px', marginTop:'4px' }}>
                    {res_getallcommunicationway_array.length > 0
                      ? res_getallcommunicationway_array.slice(0,6).map(item => (
                          <button key={item._id}
                            onClick={() => setcommunicationwat(Communicationway===item._id?'':item._id)}
                            style={{
                              padding:'7px 16px', borderRadius:'20px', fontSize:'12px',
                              fontFamily:T.bodyFont, fontWeight:'500', cursor:'pointer',
                              border: Communicationway===item._id ? `1.5px solid ${T.accent}` : `1.5px solid ${isDark?T.darkBorder:T.border}`,
                              background: Communicationway===item._id ? T.accentBg : isDark?T.darkSurface2:'#FAFBFF',
                              color: Communicationway===item._id ? T.accent : isDark?T.darkMuted:T.textMuted,
                              transition:'all .15s',
                            }}
                          >{item.name}</button>
                        ))
                      : <span style={{ fontSize:'13px', color:isDark?T.darkMuted:T.textLight, fontFamily:T.bodyFont }}>No options available</span>
                    }
                  </div>
                </div>

                {/* Lead Type */}
                <div style={{ display:'flex', alignItems:'center', gap:'12px', padding:'12px 14px', background:isDark?T.darkSurface2:T.offWhite, borderRadius:'10px', border:`1.5px solid ${isDark?T.darkBorder:'#EEF1FA'}` }}>
                  <span style={{ fontSize:'11px', color:isDark?T.darkMuted:T.textMuted, fontWeight:'700', letterSpacing:'1px', textTransform:'uppercase' }}>Lead Type:</span>
                  <Switch checked={checked} onChange={e=>setChecked(e.target.checked)} size="small"
                    sx={{ '& .MuiSwitch-thumb':{ background:checked?T.success:isDark?T.darkMuted:T.textMuted }, '& .Mui-checked+.MuiSwitch-track':{ background:T.success+'66 !important', opacity:'1 !important' } }}
                  />
                  <span style={{ fontSize:'13px', color:checked?T.success:isDark?T.darkMuted:T.textMuted, fontWeight:'500' }}>
                    {checked ? '● Fresh Lead' : '● Cold Lead'}
                  </span>
                </div>

              </div>
            </div>

            {/* ── SECTION 03 / NARRATIVE ── */}
            <div style={{ background:isDark?T.darkSurface:T.surface, border:`1px solid ${isDark?T.darkBorder:T.border}`, borderRadius:'12px', padding:'28px' }}>
              <SectionTag number={3} label="Narrative" />
              <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>

                <div>
                  <FieldLabel isDark={isDark}>Job Description (Optional)</FieldLabel>
                  <textarea value={jobDescription} onChange={e=>setJobDescription(e.target.value)} rows={3}
                    style={{ ...inputStyle, resize:'vertical', lineHeight:'1.6' }}
                    placeholder="Professional background..."
                    onFocus={e=>{ e.target.style.borderColor=T.accent; e.target.style.boxShadow=`0 0 0 3px rgba(13,71,161,0.08)`; }}
                    onBlur={e=>{ e.target.style.borderColor=isDark?T.darkBorder:T.border; e.target.style.boxShadow='none'; }}
                  />
                </div>

                <div>
                  <FieldLabel isDark={isDark}>Budget Allocation (Optional)</FieldLabel>
                  <div style={{ position:'relative' }}>
                    <span style={{ position:'absolute', left:'14px', top:'50%', transform:'translateY(-50%)', color:isDark?T.darkMuted:T.textMuted, fontSize:'14px', fontWeight:'600' }}>$</span>
                    <input value={budget} onChange={e=>setbudget(e.target.value)}
                      style={{ ...inputStyle, paddingLeft:'30px' }} type="number" placeholder="5,000,000"
                      onFocus={e=>{ e.target.style.borderColor=T.accent; e.target.style.boxShadow=`0 0 0 3px rgba(13,71,161,0.08)`; }}
                      onBlur={e=>{ e.target.style.borderColor=isDark?T.darkBorder:T.border; e.target.style.boxShadow='none'; }}
                    />
                  </div>
                </div>

                <div>
                  <FieldLabel isDark={isDark}>Internal Executive Notes (Optional)</FieldLabel>
                  <textarea value={note} onChange={e=>setNote(e.target.value)} rows={4}
                    style={{ ...inputStyle, resize:'vertical', lineHeight:'1.6' }}
                    placeholder="Confidential details regarding lead quality or specific requests..."
                    onFocus={e=>{ e.target.style.borderColor=T.accent; e.target.style.boxShadow=`0 0 0 3px rgba(13,71,161,0.08)`; }}
                    onBlur={e=>{ e.target.style.borderColor=isDark?T.darkBorder:T.border; e.target.style.boxShadow='none'; }}
                  />
                </div>

                {isAdminOrMarketer && (
                  <div>
                    <FieldLabel isDark={isDark}>
                      Campaign Redirect Link
                      <span style={{ fontWeight:'400', textTransform:'none', letterSpacing:0, fontSize:'11px', color:isDark?T.darkMuted:T.textLight, marginLeft:'6px' }}>(optional)</span>
                    </FieldLabel>
                    <input value={campaignRedirectLink} onChange={e=>setCampaignRedirectLink(e.target.value)}
                      style={inputStyle} type="url" placeholder="https://example.com/campaign-link"
                      onFocus={e=>{ e.target.style.borderColor=T.accent; e.target.style.boxShadow=`0 0 0 3px rgba(13,71,161,0.08)`; }}
                      onBlur={e=>{ e.target.style.borderColor=isDark?T.darkBorder:T.border; e.target.style.boxShadow='none'; }}
                    />
                  </div>
                )}

              </div>
            </div>
          </div>

          {/* ══ SECTION 04 / INTELLIGENCE ══ */}
          {isAdminOrMarketer && (
            <SectionCard isDark={isDark}>
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'20px' }}>
                <SectionTag number={4} label="Intelligence" />
                <button
                  onClick={addQuestion} disabled={questions.length >= 5}
                  style={{
                    display:'flex', alignItems:'center', gap:'6px',
                    padding:'7px 16px', borderRadius:'20px', fontSize:'12px',
                    fontFamily:T.bodyFont, fontWeight:'600',
                    cursor:questions.length>=5?'not-allowed':'pointer',
                    border:`1.5px solid ${questions.length>=5?(isDark?T.darkBorder:T.border):T.accent}`,
                    background:questions.length>=5?(isDark?T.darkSurface2:T.offWhite):T.accentBg,
                    color:questions.length>=5?(isDark?T.darkMuted:T.textMuted):T.accent,
                    letterSpacing:'1px', textTransform:'uppercase',
                    opacity:questions.length>=5?0.6:1, transition:'all .2s',
                  }}
                >
                  <AddIcon style={{ fontSize:'14px' }} />
                  + Add Custom Metric
                </button>
              </div>

              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'16px' }}>
                {questions.map((q, idx) => (
                  <div key={q.id} style={{ background:isDark?T.darkSurface2:T.offWhite, borderRadius:'10px', border:`1.5px solid ${isDark?T.darkBorder:'#EEF1FA'}`, padding:'16px', position:'relative' }}>
                    {questions.length > 1 && (
                      <button onClick={()=>removeQuestion(q.id)}
                        style={{ position:'absolute', top:'10px', right:'10px', background:'transparent', border:'none', cursor:'pointer', color:isDark?T.darkMuted:T.textLight, padding:'2px', display:'flex', alignItems:'center' }}>
                        <RemoveIcon style={{ fontSize:'16px' }} />
                      </button>
                    )}
                    <div style={{ marginBottom:'10px' }}>
                      <FieldLabel isDark={isDark}>{idx===0?'Investment Horizon':idx===1?'Preferred Aesthetic':`Question ${idx+1}`}</FieldLabel>
                      <input value={q.question} onChange={e=>updateQuestionText(q.id,e.target.value)}
                        style={{ ...inputStyle, background:isDark?T.darkSurface:T.surface }}
                        placeholder="Enter Question Label..."
                        onFocus={e=>{ e.target.style.borderColor=T.accent; e.target.style.boxShadow=`0 0 0 3px rgba(13,71,161,0.08)`; }}
                        onBlur={e=>{ e.target.style.borderColor=isDark?T.darkBorder:T.border; e.target.style.boxShadow='none'; }}
                      />
                    </div>
                    <div>
                      <input value={q.answer} onChange={e=>updateQuestionAnswer(q.id,e.target.value)}
                        style={{ ...inputStyle, background:isDark?T.darkSurface:T.surface }}
                        placeholder="Enter Expected Answer..."
                        onFocus={e=>{ e.target.style.borderColor=T.accent; e.target.style.boxShadow=`0 0 0 3px rgba(13,71,161,0.08)`; }}
                        onBlur={e=>{ e.target.style.borderColor=isDark?T.darkBorder:T.border; e.target.style.boxShadow='none'; }}
                      />
                    </div>
                  </div>
                ))}
              </div>
              {questions.length >= 5 && (
                <p style={{ marginTop:'10px', fontSize:'12px', color:T.warning, fontFamily:T.bodyFont }}>
                  ⚠ Maximum 5 custom metrics allowed
                </p>
              )}
            </SectionCard>
          )}

          {/* ══ ACTIONS ══ */}
          <div style={{ display:'flex', justifyContent:'flex-end', gap:'12px', padding:'8px 0 16px' }}>
            <button onClick={resetForm}
              style={{ padding:'11px 28px', background:'transparent', border:`1.5px solid ${isDark?T.darkBorder:T.border}`, borderRadius:'10px', color:isDark?T.darkMuted:T.textMuted, fontSize:'13px', fontWeight:'500', cursor:'pointer', fontFamily:T.bodyFont, transition:'all .2s' }}
              onMouseOver={e=>{ e.currentTarget.style.background=isDark?T.darkSurface2:T.offWhite; }}
              onMouseOut={e=>{ e.currentTarget.style.background='transparent'; }}>
              Clear Form
            </button>
            <button
              onClick={!submitLoading ? onSubmit : undefined}
              disabled={submitLoading || isPhoneDuplicate}
              style={{ padding:'11px 32px', background:isPhoneDuplicate?(isDark?'#374151':'#9ca3af'):T.accent, border:'none', borderRadius:'10px', color:'#fff', fontSize:'13px', fontWeight:'600', cursor:submitLoading||isPhoneDuplicate?'not-allowed':'pointer', fontFamily:T.bodyFont, display:'flex', alignItems:'center', gap:'8px', opacity:submitLoading||isPhoneDuplicate?0.75:1, transition:'all .2s' }}
              onMouseOver={e=>{ if(!submitLoading&&!isPhoneDuplicate) e.currentTarget.style.opacity='0.88'; }}
              onMouseOut={e=>{ if(!submitLoading&&!isPhoneDuplicate) e.currentTarget.style.opacity='1'; }}
            >
              {submitLoading
                ? <><CircularProgress size={16} style={{ color:'white' }} /> Processing...</>
                : isPhoneDuplicate ? 'Duplicate Lead'
                : <><AddIcon style={{ fontSize:'17px' }} /> Create New Lead</>
              }
            </button>
          </div>

      

        </div>

        {/* Footer */}
        <footer style={{ padding:'16px 28px', flexShrink:0, fontSize:'12px', color:isDark?'#4b5563':'#9ca3af', fontFamily:T.bodyFont, borderTop:`1px solid ${isDark?T.darkBorder:T.border}`, textAlign:'center' }}>
          © 2026 Jinn Estate CRM • Secure Multi-Tenant Architecture
        </footer>
      </div>
    </div>
  );
};
